import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Box,
  Container,
  Paper,
  Typography,
  TextField,
  Avatar,
  Autocomplete,
  Chip,
  CircularProgress,
  Stack,
  Grid,
  Button,
  Tabs,
  Tab,
  Divider,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  FormControl,
  InputLabel, 
  Select,
  MenuItem,
  TablePagination,
  TableContainer,
  FormControlLabel,
  Checkbox ,
  FormHelperText,
  InputAdornment,
  Collapse,
} from "@mui/material";
import {
  Person,
  Search,
  LocalHospital,
  Science,
  Notes,
  LocalPharmacy,
  CalendarMonth,
  Print,
  Send,
  History,
  Close,
  Scanner,
  Medication,
  RoomService,
  Hotel,
  PersonAdd ,
   AutoAwesome ,
   CameraAlt ,Delete ,Info,
   NoteAlt,
} from "@mui/icons-material";

import "react-quill/dist/quill.snow.css";
import axios from "axios";
import { Tooltip } from "@mui/material";

import { suggestionsData } from "../data/suggestionsData";
import { diagnosisRules } from "../data/diagnosisRules";
import SaveIcon from "@mui/icons-material/Save";
import { Edit, ArrowBack, ArrowBackIosNew, ArrowForwardIos, WarningAmber, EventBusy, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import PatientTable from '../Wards/PatientTable';
import { ErrorMessage, successMessage ,frequencyMap ,frequencyMultiplier ,standardFrequencies ,MEDICATION_ROUTES} from "../Message";

import { loadAllInPatients , loadInsuredServicesdb ,loadDoctorSuggestionsInpatient ,loadInPatientDiagnosis ,loadPatientDiagnosisdb 
  ,servicesToday ,saveServiceProvideddb ,saveOrUpdateDiagnosisdb ,loadDiagnosisOptionsdb ,loadProcedureOptionsdb ,
  saveOrUpdateDiagnosisDocumetingdb ,saveOrUpdateProceduresDocumetingdb ,loadLabdb ,requestLab ,loadRequestedLabsInpatients
 ,deleteRequestedLabdb ,loadAvailableScansdb ,loadRequestedScanInpatient ,loadMedicationsdb ,addMedicationdb , loadRequestedMedsInpatient 
  ,updateMedicationdb ,medicationdeletedb ,loadOtherServicesdb ,requestOtherService ,loadRequestedOtherServicesInpatient ,saveAppointmentdb, DischargePatient ,
  loadAppointmentsdb, updateAppointmentdb, deleteAppointmentdb ,getPatientAppointmentdb ,loadMedicationByAge ,loadWardRoundsdb ,deleteOrReverseOtherServicedb , 
  inpatientStatsdb ,ReAdmitPatient ,DeadchargePatient, notifyPharmacyRestock, medicationStock,
  loadDetentionReviewsDuedb, convertDetentionToAdmissiondb, complianceFollowup } from '../BaseURL';

import LockIcon from "@mui/icons-material/Lock";
import Swal from "sweetalert2";
import { formatWithOutSom } from "../Message";
import MedicalHistoryDialog from "./MedicalHistoryDialog";
import LabHistoryDialog from "./LabHistoryDialog";
import ScanHistoryDialog from "./ScanHistoryDialog";
import MedicationHistory from "../Pharmacy/MedicationHistory";
import VitalsHistoryDialog from "./VitalsHistoryDialog";
import WardRoundsDialog from "./WardRoundsDialog";
import SpecialPrecautionDialog from "./SpecialPrecautionDialog";
import moment from "moment";
import AirlineSeatFlatAngledIcon from '@mui/icons-material/AirlineSeatFlatAngled';
import RestockNotificationDialog from "../Pharmacy/RestockNotificationDialog";
import { matchSavedByName } from '../matchSavedByName';

const InPatient = () => {

   const [InpatientStats, setInpatientStats] = useState({
    totalOutpatients: 0,
    maleCount: 0,
    femaleCount: 0,
    pediatricsCount: 0,
    adultCount: 0
  });

  const currentDate = moment().format('YYYY-MM-DD'); // 2025-11-26
  const [loading, setLoading] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  
  const [allPatients ,setAllPatients] = useState([]);

  // Auto-collapsing patient banner via IntersectionObserver on a sentinel —
  // see Wards/InPatient.js for the rationale. Cooldown prevents the layout
  // shift caused by the Collapse animation from immediately re-triggering
  // the observer (the scroll-listener version bounced in/out endlessly).
  const [bannerCollapsed, setBannerCollapsed] = useState(false);
  const [bannerManual, setBannerManual]       = useState(false);
  const bannerSentinelRef = useRef(null);
  const bannerCooldownRef = useRef(false);
  useEffect(() => {
    if (bannerManual) return;
    const el = bannerSentinelRef.current;
    if (!el || typeof IntersectionObserver === 'undefined') return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (bannerCooldownRef.current) return;
        bannerCooldownRef.current = true;
        setTimeout(() => { bannerCooldownRef.current = false; }, 350);
        setBannerCollapsed(!entry.isIntersecting);
      },
      { threshold: 0, rootMargin: '-80px 0px 0px 0px' }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [bannerManual, selectedPatient?.id]);
  useEffect(() => {
    setBannerCollapsed(false);
    setBannerManual(false);
  }, [selectedPatient?.id]);

const [serviceProvided, setServiceProvided] = useState('');
const [attendanceType, setAttendanceType] = useState('');


const [medHistoryOpen, setMedHistoryOpen] = useState(false);
const [labHistoryOpen, setlabHistoryOpen] = useState(false);
const [ScanHistoryOpen, setScanHistoryOpen] = useState(false);
const [openmedHis, setopenmedHis] = useState(false);
const [vitalsHistoryOpen, setVitalsHistoryOpen] = useState(false);

const [precautionDialogOpen, setPrecautionDialogOpen] = useState(false);
const [complaint, setComplaint] = useState("");
const [history, setHistory] = useState("");
const [exam, setExam] = useState("");
const [other, setOther] = useState("");
const [detentionTimeLeft, setDetentionTimeLeft] = useState('');
const [admissionStatusError, setAdmissionStatusError] = useState(false);

const [manualServiceName, setManualServiceName] = useState("");
const [manualQty, setManualQty] = useState(1);
const [manualAmount, setManualAmount] = useState("");

const [medInfoDialogOpen, setMedInfoDialogOpen] = useState(false);
const [selectedMedInfo, setSelectedMedInfo] = useState(null);
const [medInfoLoading, setMedInfoLoading] = useState(false);

const [restockCount, setRestockCount]         = useState(0);
const [stockWarningDialog, setStockWarningDialog] = useState(false);
const [stockWarningInfo, setStockWarningInfo]   = useState(null);
const [notifyingPharmacy, setNotifyingPharmacy] = useState(false);

useEffect(() => {
  if (!selectedPatient || selectedPatient.state !== 'Detention') {
    setDetentionTimeLeft('');
    return;
  }

  const calculateTimeLeft = () => {
    if (!selectedPatient.currtime) return '';

    const detentionStart = moment(selectedPatient.currtime);
    const now = moment();
    const detentionEnd = detentionStart.clone().add(30, 'hours');
    
    const hoursLeft = detentionEnd.diff(now, 'hours');
    const minutesLeft = detentionEnd.diff(now, 'minutes') % 60;

    if (hoursLeft < 0) {
      return 'EXPIRED';
    }

    return `${hoursLeft}h ${minutesLeft}m`;
  };

  // Calculate immediately
  setDetentionTimeLeft(calculateTimeLeft());

  // Update every minute
  const interval = setInterval(() => {
    setDetentionTimeLeft(calculateTimeLeft());
  }, 60000); // Update every 60 seconds

  return () => clearInterval(interval);
}, [selectedPatient]);


// ── Patient navigation (prev / next within the worklist) ───────────────
const currentPatientIndex = selectedPatient
  ? allPatients.findIndex(p => p.id === selectedPatient.id)
  : -1;
const hasPrevPatient = currentPatientIndex > 0;
const hasNextPatient = currentPatientIndex >= 0 && currentPatientIndex < allPatients.length - 1;
const goToPrevPatient = () => {
  if (hasPrevPatient) setSelectedPatient(allPatients[currentPatientIndex - 1]);
};
const goToNextPatient = () => {
  if (hasNextPatient) setSelectedPatient(allPatients[currentPatientIndex + 1]);
};

// Keyboard shortcuts: ← previous patient · → next patient
// Disabled while typing in inputs/textareas/selects.
useEffect(() => {
  if (!selectedPatient) return;
  const onKey = (e) => {
    const tag = (e.target?.tagName || '').toLowerCase();
    const editable = e.target?.isContentEditable;
    if (tag === 'input' || tag === 'textarea' || tag === 'select' || editable) return;
    if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
    if (e.key === 'ArrowLeft')  { e.preventDefault(); goToPrevPatient(); }
    if (e.key === 'ArrowRight') { e.preventDefault(); goToNextPatient(); }
  };
  window.addEventListener('keydown', onKey);
  return () => window.removeEventListener('keydown', onKey);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [selectedPatient, allPatients]);


// ── Detention reviews due (24h+ detentions awaiting doctor decision) ──
const [reviewsDue, setReviewsDue] = useState([]);
const [reviewsDueLoading, setReviewsDueLoading] = useState(false);
const [reviewsDialogOpen, setReviewsDialogOpen] = useState(false);
const [reviewsSearch, setReviewsSearch] = useState('');

// Filter reviews by name / patient ID / ward / bed / detaining doctor
const filteredReviewsDue = useMemo(() => {
  const q = reviewsSearch.trim().toLowerCase();
  if (!q) return reviewsDue;
  return reviewsDue.filter(p =>
    String(p.fullName || '').toLowerCase().includes(q) ||
    String(p.id || '').toLowerCase().includes(q) ||
    String(p.ward_name || '').toLowerCase().includes(q) ||
    String(p.bed_number || '').toLowerCase().includes(q) ||
    String(p.detaining_doctor || '').toLowerCase().includes(q)
  );
}, [reviewsDue, reviewsSearch]);

// Reset search whenever the dialog opens fresh
useEffect(() => { if (!reviewsDialogOpen) setReviewsSearch(''); }, [reviewsDialogOpen]);
const [dischargeDialogOpen, setDischargeDialogOpen] = useState(false);
const [dischargingNow, setDischargingNow] = useState(false);

// ── WHY THE DISCHARGE FAILED, IN WORDS SOMEBODY CAN ACT ON ──────────────────
//
//  A doctor pressed Discharge and got a dialog reading exactly:
//
//      Error
//      Error discharging patient
//
//  and nothing else. That is `data.message` — a FIXED string in the route's catch
//  block, identical for every possible failure. The route also sends the real
//  reason as `data.error`, and both call sites read only `message`, so the one
//  useful fact was discarded one line before the screen.
//
//  ── AND THE KNOWN CAUSE IS NAMED, NOT JUST PRINTED ──────────────────────────
//  The failure this most often is: `admmission_information` has a unique index on
//  an open admission (migration 029, uniq_open_admission_per_patient) and the
//  discharge INSERT once omitted `status`, which DEFAULTS to 1 — "on the ward".
//  So a discharge tried to create a second OPEN admission for the patient it was
//  discharging, the index refused it, and the transaction rolled back. The fix is
//  `status = 3` on that insert and it is in server.js — but a server still running
//  the older file fails on every discharge, and "Duplicate entry" tells a doctor
//  nothing about that.
//
//  So a duplicate-key failure says what it means and who can fix it. Anything
//  else is shown verbatim, because a message nobody anticipated is still far more
//  use than the fixed string.
const dischargeFailureHtml = (data, err) => {
  const raw = String(data?.error || data?.message || err?.message || '').trim();
  const esc = (s) => String(s).replace(/[&<>]/g,
    (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]));

  const known = /duplicate entry/i.test(raw) && /open_admission|admmission/i.test(raw)
    ? 'This patient already has an open admission on record, so the discharge '
      + 'could not be written. It is a known server fault — the discharge tries to '
      + 'open a second admission instead of closing the first — and it is fixed in '
      + 'the current backend. Ask ICT whether this server has that update.'
    : /duplicate entry/i.test(raw)
      ? 'Something the discharge writes already exists on this patient, so the '
        + 'database refused it. Nothing has been changed. Send this message to ICT.'
      : null;

  return `<div style="text-align:left;font-size:13px;line-height:1.6;color:#334155">
    ${known ? `<p style="margin:0 0 10px">${known}</p>` : ''}
    <p style="margin:0 0 6px;color:#64748b;font-size:12px">
      ${known ? 'What the server reported' : 'The server reported'}:</p>
    <div style="padding:8px 10px;border:1px solid #e5e9ef;border-radius:6px;
                background:#f8fafc;font-family:ui-monospace,Consolas,monospace;
                font-size:12px;word-break:break-word;color:#0f172a">
      ${esc(raw || 'no reason given')}
    </div>
    <p style="margin:10px 0 0;color:#64748b;font-size:12px">
      The patient has NOT been discharged and nothing was changed. Nothing is lost
      by trying again.</p>
  </div>`;
};

// Submit discharge from the popup dialog. Same path as the existing
// tab-6 form (POST /DischargePatient), but without the redundant Swal
// confirm — the dialog itself is the confirmation step.
const handleDischargeFromDialog = async () => {
  if (!selectedPatient) return;
  if (!admissionDate) { ErrorMessage('Missing Field', 'Please select Date'); return; }
  if (!admissionTime) { ErrorMessage('Missing Field', 'Please select Time'); return; }
  if (!String(admissionNote || '').trim()) {
    ErrorMessage('Missing Field', 'Discharge note cannot be empty');
    return;
  }
  setDischargingNow(true);
  try {
    const res = await axios.post(DischargePatient, {
      patientId:   selectedPatient.id,
      name:        selectedPatient.fullName,
      age:         selectedPatient.age,
      gender:      selectedPatient.gender,
      admissionStatus,
      admissionDate,
      admissionTime,
      admissionNote,
      dat:         currentDate,
      visitDate:   selectedPatient.visitDate,
      currentUser,
    });
    if (res.data?.success) {
      Swal.fire({
        icon: 'success',
        title: 'Patient Discharged',
        text: 'The discharge has been recorded. The case is now in the nurse discharge queue.',
        timer: 2200, showConfirmButton: false,
      });
      // Reset form-like state and clear selection
      setAdmissionStatus('');
      setAdmissionNote('');
      setTreatmentPlan('');
      setDischargeDialogOpen(false);
      setSelectedPatient(null);
      if (typeof loadPatients === 'function') loadPatients();
      loadReviewsDue();
    } else {
      Swal.fire('Error', res.data?.message || 'Discharge failed.', 'error');
    }
  } catch (err) {
    const data = err.response?.data;
    if (err.response?.status === 409 && data?.blocked && Array.isArray(data.incompleteDays)) {
      const minV = data.minVitalsPerDay ?? data.minPerDay ?? 3;
      const minN = data.minNotesPerDay  ?? 1;
      const rows = data.incompleteDays.map(d => {
        const vColor = d.missingVitals === 0 ? '#41a386' : '#b91c1c';
        const nColor = d.missingNotes  === 0 ? '#41a386' : '#b91c1c';
        const dayMinV = d.minVitals ?? minV;
        const dayMinN = d.minNotes  ?? minN;
        const missing = [];
        if (d.missingVitals > 0) missing.push(`${d.missingVitals} vital${d.missingVitals === 1 ? '' : 's'}`);
        if (d.missingNotes  > 0) missing.push(`${d.missingNotes} note${d.missingNotes === 1 ? '' : 's'}`);
        return `
          <div style="display:flex;align-items:center;gap:8px;padding:6px 10px;border:1px solid #e5e9ef;border-radius:6px;background:#f8fafc;margin:4px 0;">
            <span style="font-weight:700;color:#0f172a;min-width:96px;">${d.date}</span>
            <span style="font-size:12px;font-weight:600;color:${vColor};">Vitals ${d.vitals}/${dayMinV}</span>
            <span style="font-size:12px;font-weight:600;color:${nColor};">Notes ${d.notes}/${dayMinN}</span>
            ${missing.length ? `<span style="font-size:12px;color:#64748b;font-style:italic;">missing: ${missing.join(', ')}</span>` : ''}
          </div>`;
      }).join('');
      Swal.fire({
        icon: 'warning',
        title: 'Discharge Blocked — Compliance Not Met',
        html:
          `<p style="color:#475569;margin:0 0 8px;font-size:13px;">
             Every admission day must have at least <strong>${minV} vitals</strong> and <strong>${minN} nursing note${minN === 1 ? '' : 's'}</strong>.
             Ask the ward nurse to record the missing entries, then try discharge again.
           </p>
           <div style="text-align:left;max-height:240px;overflow-y:auto;">${rows}</div>`,
        confirmButtonText: 'OK, I will follow up',
        confirmButtonColor: '#41a386',
        width: 560,
      }).then(result => {
        if (result.isConfirmed && selectedPatient?.id && data.admissionDate) {
          axios.post(complianceFollowup, {
            patientId: selectedPatient.id,
            admissionDate: data.admissionDate,
            requestedBy: currentUser || null,
          }).catch(e => console.error('Failed to raise compliance follow-up:', e));
        }
      });
    } else {
      //  ── SHOW WHAT ACTUALLY FAILED ────────────────────────────────────────
      //  This read `data.message` alone, which on /DischargePatient is the fixed
      //  string "Error discharging patient" — so every failure, whatever its
      //  cause, produced one dialog saying nothing. A doctor photographed it and
      //  the photograph could not be diagnosed from.
      //
      //  The server has always sent the real reason as `data.error`
      //  (`error.message` in its catch). It was being thrown away one line before
      //  it reached the screen.
      Swal.fire({
        icon: 'error',
        title: 'Discharge failed',
        html: dischargeFailureHtml(data, err),
        confirmButtonColor: '#41a386',
        width: 540,
      });
      console.error('DischargePatient failed:', data || err);
    }
  } finally {
    setDischargingNow(false);
  }
};

const loadReviewsDue = async () => {
  setReviewsDueLoading(true);
  try {
    const res = await axios.get(loadDetentionReviewsDuedb);
    if (res.data?.success) setReviewsDue(res.data.results || []);
  } catch (err) {
    console.error('loadDetentionReviewsDue failed:', err);
  } finally {
    setReviewsDueLoading(false);
  }
};

// Refresh on mount + every 5 minutes
useEffect(() => {
  loadReviewsDue();
  const t = setInterval(loadReviewsDue, 5 * 60 * 1000);
  return () => clearInterval(t);
}, []);

// Hours since the selected patient's detention started.
// Uses patient.currtime which is set when the doctor detains via /admitPatient.
const selectedHoursDetained = useMemo(() => {
  if (!selectedPatient || selectedPatient.status !== 'Detention' || !selectedPatient.currtime) return 0;
  const ms = Date.now() - new Date(selectedPatient.currtime).getTime();
  return Math.max(0, Math.floor(ms / (1000 * 60 * 60)));
}, [selectedPatient]);

const isReviewDue = selectedPatient?.status === 'Detention' && selectedHoursDetained >= 24;

const handleConvertToAdmission = async (targetPatient) => {
  const p = targetPatient || selectedPatient;
  if (!p) return;
  const result = await Swal.fire({
    title: 'Convert to Full Admission?',
    html: `<b>${p.fullName}</b> (ID ${p.id}) will be moved from <b>Detention</b> to a full <b>Admission</b>. The 24h timer no longer applies after conversion. Continue?`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#1A9B7F',
    confirmButtonText: 'Yes, Convert',
    cancelButtonText: 'Cancel',
  });
  if (!result.isConfirmed) return;
  try {
    const res = await axios.post(convertDetentionToAdmissiondb, {
      patientId: p.id,
      dat:       p.visitDate || p.dat,
      currentUser,
    });
    if (res.data?.success) {
      Swal.fire({
        icon: 'success',
        title: 'Converted',
        text: `${p.fullName} is now under Admission.`,
        timer: 1800, showConfirmButton: false,
      });
      // Refresh both worklists; clear selection so the doctor sees the updated state
      setSelectedPatient(null);
      if (typeof loadPatients === 'function') loadPatients();
      loadReviewsDue();
    } else {
      Swal.fire('Error', res.data?.message || 'Could not convert.', 'error');
    }
  } catch (err) {
    Swal.fire('Error', err.response?.data?.message || err.message || 'Conversion failed.', 'error');
  }
};


const iconStyle = (color) => ({
  backgroundColor: `rgba(${color}, 0.08)`,
  color: `rgb(${color})`,
  borderRadius: 2,
  boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
  "&:hover": {
    backgroundColor: `rgba(${color}, 0.25)`,
    transform: "scale(1.12)",
    transition: "all 0.25s ease-in-out",
  },
});



const handleReAdmitPatient = async () => {
  try {
    // 1️⃣ Show confirmation dialog
    const result = await Swal.fire({
      title: 'Re-Admit Patient?',
      text: `Do you want to re-admit ${selectedPatient.fullName} (ID: ${selectedPatient.id})?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#4caf50',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Re-Admit',
      cancelButtonText: 'Cancel'
    });

    if (!result.isConfirmed) {
      return;
    }

    setLoading(true);

    // 2️⃣ Send re-admit request to backend
    const res = await axios.post(ReAdmitPatient, {
      patientId: selectedPatient.id,
      currentUser: currentUser,
      admissionDate: selectedPatient.visitDate
    });

    // 3️⃣ Handle response
    if (res.data.success) {
      Swal.fire({
        icon: "success",
        title: "Patient Re-Admitted",
        text: res.data.message
      });

      // Reload patients list
      loadPatients();
      
      // Update selected patient state to unlock interface
      setSelectedPatient(prev => ({
        ...prev,
        state: 'inPatient'
      }));

    } else if (res.data.unauthorized) {
      // 4️⃣ Handle authorization error
      Swal.fire({
        icon: "error",
        title: "Unauthorized",
        text: res.data.message,
        confirmButtonColor: '#d33'
      });
    } else {
      // 5️⃣ Handle other errors
      Swal.fire({
        icon: "error",
        title: "Error",
        text: res.data.message
      });
    }

  } catch (error) {
    console.error("Re-admit error:", error);
    const data = error?.response?.data;
    if (data?.wardCleared) {
      Swal.fire({
        icon: 'warning',
        title: 'Patient already left the ward',
        html:
          `<p style="text-align:left;color:#475569;font-size:13px;">
             ${data.message}
           </p>
           <p style="text-align:left;color:#475569;font-size:12px;margin-top:8px;">
             The nurse has cleared this patient's bed, so they're no longer in the system as an inpatient. To bring them back in, open a fresh admission from registration.
           </p>`,
        confirmButtonColor: '#b45309',
      });
    } else {
      // Surface the DB-level error detail (data.error) when the backend
      // returns the generic "Error re-admitting patient" so we can see what
      // actually broke, instead of the vague "Error" dialog.
      const detail = data?.error && data.error !== data?.message
        ? `${data.message || 'Failed to re-admit patient.'}\n\nDetail: ${data.error}`
        : data?.message || "Failed to re-admit patient. Please try again.";
      Swal.fire({
        icon: "error",
        title: "Error",
        text: detail,
      });
    }
  } finally {
    setLoading(false);
  }
};




const [currentUser ,setcurrentUser]=useState()


const loadPatients = async () => {
setLoading(true); 
  try {
    // Doctors see every active inpatient — admissions, detentions AND
    // emergencies — so they can take care of ER patients alongside the rest.
    const response = await axios.get(loadAllInPatients);
   

     if (response.data.success) {
              
        setAllPatients(response.data.results);
              
     }
    
  } catch (error) {
    console.error("Request failed:", error);
  }finally {
    setLoading(false);  
  }
};


const [diagnosisOptions, setDiagnosisOptions] = useState([]);
const [procedureOptions ,setprocedureOptions]= useState([])


const loadDiagnosisOptions = async (age , gender , status)  => {
   setLoading(true);
  try {
    const response = await axios.get(loadDiagnosisOptionsdb, {
      params: {
        age: age,
        gender: gender ,
        status:status
      }
    });

    if (response.data.success) {
      setDiagnosisOptions(response.data.results);
    }
  } catch (error) {
    console.error('Error loading diagnosis options:', error);
  }finally {
    setLoading(false);
  }
};

const loadProcedureOptions = async (age , gender , status)  => {
 
   setLoading(true);
  try {
    const response = await axios.get(loadProcedureOptionsdb, {
      params: {
        age: age,
        gender: gender ,
        status:status
      }
    });

    if (response.data.success) {
      setprocedureOptions(response.data.results);
    }
  } catch (error) {
    console.error('Error loading diagnosis options:', error);
  }finally {
    setLoading(false);
  }
};

const loadOutpatientStats = async () => {
  try {
    const response = await axios.get(inpatientStatsdb);
    
    if (response.data.success) {
      setInpatientStats({
        totalOutpatients: response.data.total || 0,
        maleCount: response.data.male || 0,
        femaleCount: response.data.female || 0,
        pediatricsCount: response.data.pediatrics || 0,
        adultCount: response.data.adult || 0
      });
    }
  } catch (error) {
    console.error("Error loading outpatient stats:", error);
  }
}


useEffect(() => {
        
    loadPatients()
    loadOutpatientStats()
      
    const savedUserInfo = localStorage.getItem('userInfo');
      if (savedUserInfo) {
        const userInfo = JSON.parse(savedUserInfo);
        const userName = userInfo.name || ''; 
        setcurrentUser(userName)

         if (userName) loadDoctorSuggestions(userName);
      } 

}, []);

    
const [customSuggestions, setCustomSuggestions] = useState({});

const loadDoctorSuggestions = async (doctorName) => {
   setLoading(true);
  try {
    const response = await axios.get(loadDoctorSuggestionsInpatient, {
      params: { doctorName }
    });

    if (response.data.success) {
      setCustomSuggestions(response.data.data);


      // ✅ Merge backend doctor suggestions with local suggestionsData
      Object.keys(response.data.data).forEach((field) => {
        const backendItems = response.data.data[field] || [];
        const merged = [
          ...new Set([...backendItems, ...suggestionsData[field]])
        ];
        suggestionsData[field] = merged; // extend in-memory data
      });

      console.log("Updated suggestionsData with backend doctor data:", suggestionsData);
    }
  } catch (error) {
    console.error("Error loading doctor suggestions:", error);
  }finally {
    setLoading(false);
  }
};

const loadServiceAndAttendance = async (patientId , dat) => {
 setLoading(true);
  try {
    const response = await axios.get(servicesToday, {
      params: { patient_id: patientId , dat:dat }
    });

    if (response.data.success && response.data.data) {
      const { name, att } = response.data.data;
      setServiceProvided(name || '');
      setAttendanceType(att || '');
    } else {
      setServiceProvided('');
      setAttendanceType('');
    }
  } catch (error) {
    console.error('Error loading service and attendance:', error);
  }finally {
    setLoading(false);
  }
};


const [insuredServices, setInsuredServices] = useState([]);

const loadInsuredServices = async (insuranceName, patientAge) => {
  setLoading(true);
  try {
  
    const response = await axios.get(loadInsuredServicesdb, {
      params: {
        STATUS: insuranceName,
        charge_status: "Main Services",
        patientAge: patientAge, // 👈 send age here
      },
    });

    if (response.data.success) {
      setInsuredServices(response.data.results);
      console.log("Loaded insured services:", response.data.results);
    } else {
      setInsuredServices([]);
    }
  } catch (error) {
    Swal.fire({
      title: "Error",
      text: error.response?.data?.message || "Failed to load insured services",
      icon: "error",
    });
  }finally {
    setLoading(false);
  }
};


// when patient is selected, load services automatically
useEffect(() => {

  if (selectedPatient) {

    setActiveTab(0);

    // Load the patient's dashboard in a single parallel batch. See the
    // matching block in Doctors/OutPatient.js for the full rationale —
    // short version: the network requests already ran in parallel, but
    // each loader independently toggled the shared `loading` state,
    // causing 15+ back-to-back re-renders and no clear "everything is
    // loaded" signal. Promise.all gives one completion callback and
    // isolates per-endpoint failures via .catch.
    const swallow = (label) => (err) => console.error(`[Doctors/InPatient] ${label} failed:`, err);
    Promise.all([
      loadInsuredServices(selectedPatient.insurance, selectedPatient.age).catch(swallow('loadInsuredServices')),
      loadPatientDiagnosis(selectedPatient.id, selectedPatient.visitDate).catch(swallow('loadPatientDiagnosis')),
      loadServiceAndAttendance(selectedPatient.id, selectedPatient.visitDate).catch(swallow('loadServiceAndAttendance')),
      loadDiagnosisOptions(selectedPatient.age, selectedPatient.gender, selectedPatient.insurance).catch(swallow('loadDiagnosisOptions')),
      loadProcedureOptions(selectedPatient.age, selectedPatient.gender, selectedPatient.insurance).catch(swallow('loadProcedureOptions')),
      loadLabs().catch(swallow('loadLabs')),
      loadRequestedLabs().catch(swallow('loadRequestedLabs')),
      loadAvailableScans().catch(swallow('loadAvailableScans')),
      loadRequestedScan().catch(swallow('loadRequestedScan')),
      loadMedications().catch(swallow('loadMedications')),
      loadRequestedMeds().catch(swallow('loadRequestedMeds')),
      loadOtherServices().catch(swallow('loadOtherServices')),
      loadrequestedServices().catch(swallow('loadrequestedServices')),
      loadPatientAppointments().catch(swallow('loadPatientAppointments')),
      loadWardRoundsData().catch(swallow('loadWardRoundsData')),
    ]);

    if (selectedPatient.PrecautionType && selectedPatient.PrecautionType.trim() !== '') {
      setPrecautionDialogOpen(true);
    }
  }
}, [selectedPatient]);


useEffect(() => {
  if (
    selectedPatient &&
    selectedPatient.id &&
    diagnosisOptions.length > 0 &&
    procedureOptions.length > 0 &&
    hasLoadedDiagnosis === false
  ) {
    loadPatientDiagnosis(selectedPatient.id ,selectedPatient.visitDate);
  }
}, [diagnosisOptions, procedureOptions]);


const [hasLoadedDiagnosis, setHasLoadedDiagnosis] = useState(false);
const [hasEdited, setHasEdited] = useState(false);
const [admmission_note, setadmmission_note] = useState();
const [admiAT, setadmiAT] = useState();
const [admit_by, setadmit_by] = useState();
const [Diagnosis, setDiagnosis] = useState();
const [procedure_, setprocedure_] = useState();

const loadPatientDiagnosis = async (patientId, dat) => {
  setLoading(true);
 
  try {
    const response = await axios.get(loadPatientDiagnosisdb, {
      params: { patientId, dat },
    });

    if (!response.data.success || !response.data.data) return;

    const { complaint, history, exam, other, documenting, procedure_ ,admmission_note ,admit_by ,time_admit} =
      response.data.data;

    // ✅ Load text fields
    setComplaint(complaint || "");
    setHistory(history || "");
    setExam(exam || "");
    setOther(other || "");
    setDiagnosis(documenting);
    setprocedure_(procedure_);
    setadmmission_note(admmission_note)
    setadmiAT(time_admit)
    setadmit_by(admit_by)
    // ===================================================
    // ✅ LOAD DIAGNOSES - FIXED VERSION
    // ===================================================
    if (documenting && documenting.trim() !== "") {
      const parsedDiagnosisNames = documenting
        .split(",")
        .map((item) => item.trim())
        .filter(name => name.length > 0); // remove empty strings

      const matchedDiagnosis = matchSavedByName(diagnosisOptions, parsedDiagnosisNames);

     
      
      setSelectedDiagnoses(matchedDiagnosis);
    } else {
      setSelectedDiagnoses([]);
    }

    // ===================================================
    // ✅ LOAD PROCEDURES
    // ===================================================
    if (procedure_ && procedure_.trim() !== "") {
      const parsedProcedures = procedure_
        .split(",")
        .map((p) => p.trim())
        .filter(name => name.length > 0);

      const matchedProcedures = matchSavedByName(procedureOptions, parsedProcedures);

      setSelectedProcedures(matchedProcedures);
    } else {
      setSelectedProcedures([]);
    }

  
    setHasEdited(false);
    setHasLoadedDiagnosis(true);
  } catch (error) {
    console.error("Error loading diagnosis:", error);
  } finally {
    setLoading(false);
  }
};

  // Define diagnosis options with id, GDRD code, and name

  useEffect(() => {
    if (!searchTerm || searchTerm.length < 1) {
      setSearchResults([]);
      setSearchOpen(false);
      return;
    }

    setSearchLoading(true);

    setTimeout(() => {
  const term = (searchTerm || "").toLowerCase();

  const results = allPatients.filter((p) => {
    const name = (p.fullName || "").toLowerCase();
    const id = (p.id || "").toLowerCase();
    const tel = p.tel || "";

    return (
      name.includes(term) ||
      id.includes(term) ||
      tel.includes(searchTerm)
    );
  });

  setSearchResults(results);
  setSearchOpen(true);
  setSearchLoading(false);
}, 300);

  }, [searchTerm]);


const saveServiceProvided = async (
  updateConfirmed = false,
  customType = null,
  customService = null
) => {
  // ✅ Use either passed values or current state
   setLoading(true);
  const finalAttendanceType = customType || attendanceType;
  const finalServiceProvided = customService || serviceProvided;

  // ✅ Keep backup of previous state
  const previousService = serviceProvided;
  const previousType = attendanceType;

  const selectedService = insuredServices.find(
    (s) => s.name === finalServiceProvided
  );

  try {
    const response = await axios.post(saveServiceProvideddb, {
      patient_id: selectedPatient.id,
      dat: selectedPatient.visitDate,
      service_name: finalServiceProvided,
      attendance_type: finalAttendanceType,
      insurance: selectedPatient.insurance,
      code: selectedService?.code || "",
      toup: selectedService?.toup || 0,
      amo: selectedService?.amo || 0,
      unin: selectedService?.unin || 0,
      currentUser,
      patientName: selectedPatient.fullName,
      updateConfirmed,
    });

    // 🔹 When service or attendance already exists for today
    if (response.data.exists) {
      const result = await Swal.fire({
        title: "Update Today's Record?",
        text: `A record for '${finalServiceProvided}' (${finalAttendanceType}) already exists today. Do you want to update it?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, update it",
        cancelButtonText: "No, keep existing",
      });

      if (result.isConfirmed) {
        // ✅ Proceed with update
        await saveServiceProvided(true, finalAttendanceType, finalServiceProvided);
      } else {
        // ❌ Revert both service and attendance type to previous values
        setServiceProvided(previousService);
        setAttendanceType(previousType);

        Swal.fire(
          "No Changes Made",
          `Existing Type of Attendance kept (${previousType}).`,
          "info"
        );
      }

      return;
    }

    // 🔹 Success message
    if (response.data.success) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message,
        timer: 1500,
        showConfirmButton: false,
      });
    }
  } catch (error) {
    console.error("Error saving service:", error);
    Swal.fire("Error", "Unable to save service information.", "error");
  }finally {
    setLoading(false);
  }
};

// ✅ Debounced autosave for complaint, history, exam, other
useEffect(() => {
  if (!selectedPatient || !hasLoadedDiagnosis || !hasEdited) return;
  if (!complaint && !history && !exam && !other) return;

  const timeout = setTimeout(async () => {
    try {
      await axios.post(saveOrUpdateDiagnosisdb, {
        patientId: selectedPatient.id,
        complaint,
        history,
        exam,
        other,
        doctor: currentUser,
      });
      console.log("Auto-saved diagnosis update");
    } catch (error) {
      console.error("Auto-save failed:", error);
    }
  }, 2000);

  return () => clearTimeout(timeout);
}, [complaint, history, exam, other, selectedPatient, hasLoadedDiagnosis, hasEdited]);

// ✅ Save or update diagnosis for a patient
const saveOrUpdateDiagnosis = async (selectedDiagnosesList) => {
  if (!selectedPatient || !selectedPatient.id) {
    console.warn("⚠️ No patient selected — cannot save diagnosis.");
    return;
  }

   setLoading(true);

  try {
    const response = await axios.post(saveOrUpdateDiagnosisDocumetingdb, {
      patientId: selectedPatient.id,
      dat: selectedPatient.visitDate,
      selectedDiagnoses: selectedDiagnosesList,
      gen:selectedPatient.gender,
      fullName:selectedPatient.fullName,
      age:selectedPatient.age,
      tel:selectedPatient.tel,
      dob: selectedPatient.dob ,
      patientStatus:selectedPatient.state

    });

    if (response.data.success) {
      console.log("✅ Diagnosis saved/updated successfully");
    } else {
      console.warn("⚠️ Diagnosis save failed:", response.data.message);
    }
  } catch (error) {
    console.error("❌ Error saving diagnosis:", error);
  }finally {
    setLoading(false);
  }
};

const saveOrUpdateProcedure = async (selectedProceduresList) => {
  if (!selectedPatient || !selectedPatient.id) {
    console.warn("⚠️ No patient selected — cannot save procedures.");
    return;
  }
 setLoading(true);
  try {
    const response = await axios.post(saveOrUpdateProceduresDocumetingdb, {
      patientId: selectedPatient.id,
      dat: selectedPatient.visitDate,
      selectedProcedures: selectedProceduresList,
      gen: selectedPatient.gender,
      fullName: selectedPatient.fullName,
      age: selectedPatient.age,
      tel: selectedPatient.tel,
      dob: selectedPatient.dob,
      patientStatus: selectedPatient.state,
      currentUser: currentUser
    });

    if (response.data.success) {
      console.log("✅ Procedures saved/updated successfully");

      // ✅ CHECK FOR REVERSAL MESSAGES RETURNED BY BACKEND
      if (Array.isArray(response.data.reversals) && response.data.reversals.length > 0) {
        response.data.reversals.forEach((r) => {
         
          ErrorMessage('REVERSAL REQUIRED' ,  `⚠️ REVERSAL REQUIRED\n\nProcedure: ${r.procedure}\nMessage: ${r.message}`)
        });
      }

    } else {
      console.warn("⚠️ Procedure save failed:", response.data.message);
    }

  } catch (error) {
    console.error("❌ Error saving procedures:", error);
  }finally {
    setLoading(false);
  }
};


// AI Suggestion State & Logic
const [suggestions, setSuggestions] = useState({});

const handleSuggest = (field, value, ageGroup = "adult") => {
  if (!value.trim()) return;

  // Get the most recent phrase (after comma or period)
  const phrases = value.split(/[.,]/);
  const currentPhrase = phrases[phrases.length - 1].trim();
  if (!currentPhrase) return;

  // Suggestion based on last phrase
  const fieldSuggestions = suggestionsData[field];
  let match =
    fieldSuggestions?.find((item) =>
      item.toLowerCase().includes(currentPhrase.toLowerCase())
    ) || "";

  // Smart diagnosis + procedure inference
  const lower = currentPhrase.toLowerCase();
  const matchedRules = diagnosisRules.filter(
    (rule) =>
      (rule.ageGroup === ageGroup || rule.ageGroup === "both") &&
      rule.keywords.some((k) => lower.includes(k))
  );
  const diagnoses = [...new Set(matchedRules.flatMap((r) => r.possibleDiagnosis))];
  const procedures = [...new Set(matchedRules.flatMap((r) => r.suggestedProcedures))];

  // Update local state
  setSuggestions((prev) => ({
    ...prev,
    [field]: match,
    [`${field}Diagnosis`]: diagnoses,
    [`${field}Procedures`]: procedures,
  }));
};


//Lab

const [labs, setLabs] = useState([]);
const [labSearchTerm, setLabSearchTerm] = useState("");
const [requestedLabs, setRequestedLabs] = useState([]);


const loadLabs = async () => {
  if (!selectedPatient) return;
   setLoading(true);
  try {
    const response = await axios.get(loadLabdb, {
      params: { insurance: selectedPatient.insurance }
    });

    if (response.data.success) {
      setLabs(response.data.results);
    }
  } catch (error) {
    console.error("Failed to load labs:", error);
  }finally {
    setLoading(false);
  }
};


const handleRequestLab = async (lab) => {


  // Check duplicate request for today's date
  const alreadyRequested = requestedLabs.some(
    (r) => r.lab === lab.name && r.date === currentDate
  );

  if (alreadyRequested) {
    const result = await Swal.fire({
      title: "Duplicate Request",
      text: `${lab.name} has already been requested today. Do you want to request again?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Request Again",
      cancelButtonText: "No"
    });

    if (!result.isConfirmed) {
       setLoading(false);
      return; // user cancelled
    }
  }

  // Continue to request lab
  setLoading(true);

  try {
    const response = await axios.post(requestLab, {
      patientId: selectedPatient.id,
      dat: currentDate,
      patientInsurance: selectedPatient.insurance,
      labName: lab.name,
      amount: lab.amount,
      base_cost: lab.base_cost,
      code: lab.code,
      currentUser,
      type: "Lab"
    });

    if (response.data.success) {
      loadRequestedLabs();
    }

  } catch (error) {
    ErrorMessage("Error", "Failed to request lab");
  } finally {
    setLoading(false);
  }
};



const loadRequestedLabs = async () => {
  if (!selectedPatient || !selectedPatient.id) return;

  setLoading(true);
  try {
    const response = await axios.get(loadRequestedLabsInpatients, {
      params: {
        patientId: selectedPatient.id,
        dat:selectedPatient.visitDate ,
        currentDate
      },
    });

    if (response.data.success) {
      setRequestedLabs(response.data.results);
    }

  } catch (err) {
    console.error("Failed to load requested labs:", err);
  }finally {
    setLoading(false);
  }
};


const handleDeleteRequest = async (lab) => {
  // ✅ Confirm deletion first
   setLoading(true);
  const confirmDelete = await Swal.fire({
    title: "Delete Lab Request?",
    text: `Are you sure you want to delete "${lab.lab}"?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
  });

  if (!confirmDelete.isConfirmed) {
     setLoading(false);
    return; // ✅ User cancelled → STOP
  }

  try {
    const response = await axios.post(deleteRequestedLabdb, {
      patientId: selectedPatient.id,
      labName: lab.lab,
      dat:currentDate,
      currentUser
    });

    // ✅ If backend returns reversal warning
    if (response.data.reversal) {
      ErrorMessage("REVERSAL REQUIRED", response.data.reversal);
    } else {
      Swal.fire("Deleted", response.data.message, "success");
    }

    // ✅ Refresh the table
    loadRequestedLabs();

  } catch (error) {
    Swal.fire("Error", "Failed to delete lab request", "error");
  }finally {
    setLoading(false);
  }
};

// Available Labs pagination
const [labPage, setLabPage] = useState(0);
const [labRowsPerPage, setLabRowsPerPage] = useState(10);

// Requested Labs pagination
const [reqPage, setReqPage] = useState(0);
const [reqRowsPerPage, setReqRowsPerPage] = useState(10);


// Available scans

const [scans, setscans] = useState([]);


const loadAvailableScans = async () => {
  if (!selectedPatient || !selectedPatient.insurance) return;

  setLoading(true);
  try {
    const response = await axios.get(loadAvailableScansdb, {
      params: {
        insurance: selectedPatient.insurance,
      },
    });

    if (response.data.success) {
      setscans(response.data.results);
    }

  } catch (error) {
    console.error("Error loading scans:", error);
  }finally {
    setLoading(false);
  }
};


const loadRequestedScan = async () => {
  if (!selectedPatient || !selectedPatient.id) return;
 setLoading(true);
  try {
    const response = await axios.get(loadRequestedScanInpatient, {
      params: {
        patientId: selectedPatient.id,
        dat:selectedPatient.visitDate,
        currentDate
      },
    });

    if (response.data.success) {
      setRequestedScans(response.data.results);
    }

  } catch (err) {
    console.error("Failed to load requested labs:", err);
  }finally {
    setLoading(false);
  }
};


// Scan Search
const [scanSearchTerm, setScanSearchTerm] = useState("");

// Requested Scans
const [requestedScans, setRequestedScans] = useState([]);

// Pagination for scans
const [scanPage, setScanPage] = useState(0);
const [scanRowsPerPage, setScanRowsPerPage] = useState(10);
const [reqScanPage, setReqScanPage] = useState(0);
const [reqScanRowsPerPage, setReqScanRowsPerPage] = useState(10);

// Request Scan

const handleRequestScan = async (scan) => {

  const alreadyRequested = requestedScans.some(
    (r) => (r.lab || r.scan) === (scan.name || scan.lab) && r.date==currentDate
  );

  if (alreadyRequested) {
         const result = await Swal.fire({
           title: "Duplicate Request",
           text: `${scan.name} has already been requested today. Do you want to request again?`,
           icon: "warning",
           showCancelButton: true,
           confirmButtonColor: "#3085d6",
           cancelButtonColor: "#d33",
           confirmButtonText: "Yes, Request Again",
           cancelButtonText: "No"
         });
     
         if (!result.isConfirmed) {
           setLoading(false);
           return; // user cancelled
         }
       }
 
setLoading(true);
  try {
    const response = await axios.post(requestLab, {
      patientId: selectedPatient.id,
      patientInsurance: selectedPatient.insurance,
      labName: scan.name,
      amount: scan.amount,
      base_cost: scan.tariff,
      code: scan.code,
      currentUser ,
      type:'Scan',
      dat:currentDate,
    });

    if (response.data.success) {
      loadRequestedScan();
    }

  } catch (error) {
    ErrorMessage("Error", "Failed to request Scan");
  }finally {
    setLoading(false);
  }

 
};


// Delete Scan Request
const handleDeleteScanRequest = async(scan) => {
  setLoading(true);
  //console.log(scan)
  const confirmDelete = await Swal.fire({
    title: "Delete Scan Request?",
    text: `Are you sure you want to delete "${scan.lab}"?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
  });

  if (!confirmDelete.isConfirmed) {
      setLoading(false)
      return; // ✅ User cancelled → STOP
  
  }

  try {
    const response = await axios.post(deleteRequestedLabdb, {
      patientId: selectedPatient.id,
      labName: scan.lab,
      currentUser ,
      dat:currentDate,
    });

    // ✅ If backend returns reversal warning
    if (response.data.reversal) {
      ErrorMessage("REVERSAL REQUIRED", response.data.reversal);
    } else {
      Swal.fire("Deleted", response.data.message, "success");
    }

    // ✅ Refresh the table
    loadRequestedScan();

  } catch (error) {
    Swal.fire("Error", "Failed to delete lab request", "error");
  }finally {
    setLoading(false);
  }
};

// Medication States
const [medications, setMedications] = useState([]);

const loadMedications = async () => {
  if (!selectedPatient) return;

  setLoading(true);
  try {
    const response = await axios.get(loadMedicationsdb, {
      params: { insurance: selectedPatient.insurance }
    });

    if (response.data.success) {
      setMedications(response.data.results);
    }

  } catch (error) {
    console.error("Failed to load medications:", error);
  }finally {
    setLoading(false);
  }
};

const [medSearchTerm, setMedSearchTerm] = useState("");
const [selectedMed, setSelectedMed] = useState(null);
const [dose, setDose] = useState("");
const [frequency, setFrequency] = useState("");
const [days, setDays] = useState("");
const [qty, setQty] = useState(0);
const [route, setRoute] = useState("");
const [requestedMeds, setRequestedMeds] = useState([]);

// Pagination
const [medPage, setMedPage] = useState(0);
const [medRowsPerPage, setMedRowsPerPage] = useState(10);
const [reqMedPage, setReqMedPage] = useState(0);
const [reqMedRowsPerPage, setReqMedRowsPerPage] = useState(10);
const [medError, setMedError] = useState(false);


// Add medication
const handleAddMedication = async () => {

  //console.log(requestedMeds)
  // ------------------------------------
  // ✅ VALIDATION
  // ------------------------------------
  let hasError = false;

  if (!selectedMed) {
    ErrorMessage("Error", "Please select a medication first");
    return;
  }

  if (!doseAmount) {
    setDoseAmountError(true);
    hasError = true;
  }

  if (!frequency) {
    setFrequencyError(true);
    hasError = true;
  }

  if (!days || days <= 0) {
    setDaysError(true);
    hasError = true;
  }

  if (!route) {
    setRouteError(true);
    hasError = true;
  }

  // qty validation depending on autoCalculate
  if ((!autoCalculate && (!qty || qty <= 0)) || (autoCalculate && qty <= 0)) {
    setQtyError(true);
    hasError = true;
  }

  if (hasError) return;

  // ------------------------------------
  // ✅ DUPLICATE-PREVENTION
  // ------------------------------------

  // Backend returns date format: YYYY-MM-DD
  const today = new Date().toISOString().split("T")[0];

  const alreadyRequested = requestedMeds.some(
    (r) =>
      r.drug == selectedMed.name  && r.date==currentDate            // ✅ exact match with backend date
  );

  if (alreadyRequested) {
         const result = await Swal.fire({
           title: "Duplicate Request",
           text: `${selectedMed.name} has already been requested today. Do you want to request again?`,
           icon: "warning",
           showCancelButton: true,
           confirmButtonColor: "#3085d6",
           cancelButtonColor: "#d33",
           confirmButtonText: "Yes, Request Again",
           cancelButtonText: "No"
         });
     
         if (!result.isConfirmed) {
           setLoading(false);
           return; // user cancelled
         }
       }

       // ── Stock Check ──────────────────────────────────────────────────────
  setLoading(true);
  const stockData = await loadMedicationStock(selectedMed.name);
  setLoading(false);

  const availableQty = stockData?.available_qty ?? 0;

  if (availableQty < qty) {
    setStockWarningInfo({
      drugName:       selectedMed.name,
      requestedQty:   qty,
      availableStock: availableQty,
    });
    setStockWarningDialog(true);
    return;
  }

  // ── Submit (stock is fine) ────────────────────────────────────────────
  await submitMedicationRequest();
  
};


const loadRequestedMeds = async () => {
   setLoading(true);
  try {
    const response = await axios.get(loadRequestedMedsInpatient, {
      params: { patientId: selectedPatient.id , dat:selectedPatient.visitDate, currentDate}
    });

    if (response.data.success) {
      setRequestedMeds(response.data.results);
    }
  } catch (err) {
    console.error("Error loading meds:", err);
  }finally {
    setLoading(false);
  }
};



const submitMedicationRequest = async () => {
  setLoading(true);
  try {
    const response = await axios.post(addMedicationdb, {
      patientId:  selectedPatient.id,
      selectedMed,
      qty,
      frequency,
      route,
      doseAmount,
      days,
      currentUser,
      insurance:  selectedPatient.insurance,
      dat:        currentDate,
      age:        selectedPatient.age,
    });

    if (response.data.success) {
      loadRequestedMeds();
      handleClearMedication();
      setStockWarningDialog(false);
    }
  } catch (err) {
    ErrorMessage("Error", "Failed to save medication");
  } finally {
    setLoading(false);
  }
};

const handleNotifyPharmacy = async () => {
  setNotifyingPharmacy(true);
  try {
    await axios.post(notifyPharmacyRestock, {
      drugName:       stockWarningInfo.drugName,
      requestedQty:   stockWarningInfo.requestedQty,
      availableStock: stockWarningInfo.availableStock,
      patientId:      selectedPatient.id,
      patientName:    selectedPatient.fullName,
      doctorName:     currentUser,
    });

    setStockWarningDialog(false);
    ErrorMessage("Info", "Pharmacy has been notified to restock. Request was not submitted.");
  } catch (err) {
    ErrorMessage("Error", "Failed to notify pharmacy");
  } finally {
    setNotifyingPharmacy(false);
  }
};


const handleClearMedication = () => {
  setSelectedMed(null);
  setDoseAmount("");
  setDoseUnit("");
  setFrequency("");
  setDays("");
  setQty(0);
  setRoute("");
  setAutoCalculate(true);
  
  // reset errors
  setDoseAmountError(false);
  setFrequencyError(false);
  setDaysError(false);
  setRouteError(false);
  setQtyError(false);
  setMedError(false);

  // ✅ reset editing mode so button goes back to "Make Request"
  setEditingIndex(null);
};

 
// Delete medication
const handleDeleteMedication = async (med) => {

  setLoading(true);
  const confirmDelete = await Swal.fire({
    title: "Delete Medication?",
    text: `Are you sure you want to delete "${med.drug || "this medication"}"?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
  });

  if (!confirmDelete.isConfirmed){
     setLoading(false);
      return;
  } // user cancelled

  try {
    // 2️⃣ Send delete request (POST)
    const response = await axios.post(medicationdeletedb, {
      trans_code: med.trans_code,
      patientId: selectedPatient.id,
      insurance: selectedPatient.insurance,
      dat:currentDate,
    });

    // 3️⃣ If backend says reversal required
    if (response.data.reversalRequired) {
      Swal.fire(
        "REVERSAL REQUIRED",
        response.data.message ||
          "This medication has already been paid for. Refund/reversal is required.",
        "warning"
      );
      return;
    }

    // 4️⃣ Successful deletion
    if (response.data.success) {
      Swal.fire("Deleted", response.data.message, "success");
      loadRequestedMeds(); // refresh table
      return;
    }

    // 5️⃣ Backend returned an error
    Swal.fire(
      "Error",
      response.data.message || "Could not delete medication.",
      "error"
    );

  } catch (error) {
    console.error("DELETE MEDICATION ERROR:", error);
    Swal.fire("Error", "Something went wrong.", "error");
  }finally {
    setLoading(false);
  }
};


// Edit medication
const [editingIndex, setEditingIndex] = useState(null);
const [EditMad , setEditMad] =useState()

const handleEditMedication = (idx) => {
  const med = requestedMeds[idx];

  setEditMad(med)
  setSelectedMed({ name: med.drug });
  setDoseAmount(med.dose.split(" ")[0]);
  setDoseUnit(med.dose.split(" ")[1] || "");
  setFrequency(med.freq);
  setDays(med.days);
  setQty(med.qty);
  setRoute(med.route);
  setAutoCalculate(true);
  setEditingIndex(idx); // mark edit mode
};


const handleUpdateMedication = async () => {
  if (!EditMad || !EditMad.trans_code) {
    ErrorMessage("Error", "No medication selected for update.");
    return;
  }

  let hasError = false;

  if (!doseAmount) {
    setDoseAmountError(true);
    hasError = true;
  }
  if (!frequency) {
    setFrequencyError(true);
    hasError = true;
  }
  if (!days || days <= 0) {
    setDaysError(true);
    hasError = true;
  }
  if (!route) {
    setRouteError(true);
    hasError = true;
  }
  if ((!autoCalculate && (!qty || qty <= 0)) || (autoCalculate && qty <= 0)) {
    setQtyError(true);
    hasError = true;
  }

  if (hasError) return;

  setLoading(false);
  try {
    const response = await axios.post(updateMedicationdb, {
      trans_code: EditMad.trans_code, // ✅ identify the record
      doseAmount,
      frequency,
      days,
      route,
      qty,
      currentUser,
      patientId: selectedPatient.id,
      insurance: selectedPatient.insurance,
      dat:currentDate,
    });

    if (response.data.success) {
      successMessage("Success", "Medication updated successfully");
      loadRequestedMeds();  // reload data
      handleClearMedication();
    } else {
      ErrorMessage("Error", response.data.message || "Failed to update medication");
    }
  } catch (error) {
    ErrorMessage("Error", "Unable to update medication");
    console.error("Update medication error:", error);
  }finally {
    setLoading(false);
  }
};


const [medDialogOpen, setMedDialogOpen] = useState(false);

// Helper function
const normalizeFrequency = (freq) => {
  if (!freq) return "";
  return frequencyMap[freq.toLowerCase().trim()] || freq;
};


const [doseAmount, setDoseAmount] = useState("");
const [doseUnit, setDoseUnit] = useState("");

const [autoCalculate, setAutoCalculate] = useState(true);


const isLiquidUnit = (unit = "") => {
  const liquidUnits = [
  "ml", "mls", "mg/ml", "g/ml", "mcg/ml", "iu/ml", 
  "%", "vial", "amp", "syrup", "suspension", "solution",
  "drop", "drops", "inhalation"
];
  return liquidUnits.some(u => unit.toLowerCase().includes(u));
  
};

const autoCalcUnits = [
  "tab", "tablet",
  "cap", "capsule",
  "pill", "lozenge", "suppository",
  "amp", "vial"
];

const isAutoCalcUnit = (unit = "") => {
  return autoCalcUnits.some(u => unit.toLowerCase().includes(u));
};

const solidKeywords = ["tablet", "tab", "capsule", "cap", "pill", "lozenge", "suppository"];
const isSolidByName = (name = "") => {
  return solidKeywords.some(k => name.toLowerCase().includes(k));
};



useEffect(() => {
  if (!autoCalculate) return; // if OFF, skip auto calculation

  const nextQty = computeQty({
    doseAmount,
    doseString: dose,
    days,
    frequency,
    doseUnit,
    normalizeFrequencyFn: normalizeFrequency,
    freqMultiplierMap: frequencyMultiplier,
  });
  setQty(nextQty);
}, [doseAmount, dose, days, frequency, doseUnit, autoCalculate]);



// Support unicode fractions in dose like "½"
const FRACTION_MAP = { "¼": 0.25, "½": 0.5, "¾": 0.75 };
const normalizeUnicodeFractions = (s) =>
  String(s || "").replace(/[¼½¾]/g, (m) => String(FRACTION_MAP[m] ?? m));

/** Extract numeric part from a dose string like "500ml", "1/2 tab", "½ cap", "5 mg" */
const parseDoseNumber = (doseStr) => {
  if (!doseStr) return 0;
  const cleaned = normalizeUnicodeFractions(doseStr).trim().toLowerCase();
  // match  number (int/decimal or fraction) at the start
  const m = cleaned.match(/^(\d+(?:\.\d+)?|\d+\/\d+)/);
  if (!m) return 0;
  if (m[1].includes("/")) {
    const [a, b] = m[1].split("/").map(Number);
    return b ? a / b : Number(m[1]) || 0;
  }
  return parseFloat(m[1]) || 0;
};

/** Compute quantity from either split doseAmount or free-text dose */
const computeQty = ({ doseAmount, doseString, days, frequency, doseUnit, normalizeFrequencyFn, freqMultiplierMap }) => {
  const normalized = normalizeFrequencyFn(frequency || "");
  const perDay = freqMultiplierMap[normalized] ?? 1;

  const amount =
    doseAmount !== "" && doseAmount !== null && doseAmount !== undefined
      ? Number(doseAmount)
      : parseDoseNumber(doseString);

  if (!amount || !Number(days)) return 0;

  // ✅ If liquid, don’t multiply by perDay (doctor prescribes total volume per day)
  if (isLiquidUnit(doseUnit)) {
    return Math.ceil(Number(amount) * Number(days));
  }

  // ✅ Solid form: multiply dose × days × frequency
  return Math.ceil(Number(amount) * Number(days) * Number(perDay));
};


const loadLastMedicationPattern = async (selectedMedName, patientAge) => {
  try {
    const ageGroup = patientAge >= 12 ? "adult" : "child";

    const res = await axios.get(loadMedicationByAge, {
      params: { name: selectedMedName, age:ageGroup }
    });

    if (res.data.success) {
      const p = res.data.med;

      // 🔥 Auto-fill only if backend found data
      setDoseAmount(p.dose);
      setFrequency(p.freq);
      setDays(p.day_server);
      setRoute(p.rou);
      setQty(p.qua);

      
    }else {
      setDoseAmount('');
      setFrequency('');
      setDays('');
      setRoute('');
      setQty('');
    }
  } catch (error) {
    console.log("Error loading medication pattern:", error);
  }
};



const loadMedicationStock = async (medicationName) => {
  try {
    const response = await axios.get(medicationStock, {
      params: { name: medicationName }
    });
    if (response.data.success) {
      return response.data.stock;
    }
    return null;
  } catch (error) {
    console.error("Error loading medication stock:", error);
    return null;
  }
};


const handleMedicationInfo = async (med) => {
  setMedInfoLoading(true);
  setSelectedMedInfo(med);
  setMedInfoDialogOpen(true);
  
  try {
    const stockInfo = await loadMedicationStock(med.name);
    setSelectedMedInfo({ ...med, ...stockInfo });
  } catch (error) {
    console.error("Error loading stock:", error);
    ErrorMessage("Error", "Failed to load stock information");
  } finally {
    setMedInfoLoading(false);
  }
};

const extractStrengthFromName = (name) => {
  if (!name) return { medName: "", medStrength: "" };

  loadLastMedicationPattern(name, selectedPatient.age);

  let medName = name.trim();
  let medStrength = "";

  // Case 1: If there is a comma, assume strength is after the last comma
  if (name.includes(",")) {
    const parts = name.split(",");
    medName = parts.slice(0, -1).join(",").trim();
    medStrength = parts[parts.length - 1].trim();
  } else {
    // Case 2: If it ends with (...) → treat last parentheses as strength
    const parenMatch = name.match(/^(.*)\(([^()]*)\)\s*$/);
    if (parenMatch) {
      medName = parenMatch[1].trim();
      medStrength = parenMatch[2].trim();
    } else {
      // Case 3: Try to match trailing numeric + unit like "80mg/mL", "0.5%", "125mls"
      const match = name.match(/(.*?)(\d+(?:\.\d+)?\s?(?:mg\/ml|mg|g|mcg|ml|mls|%|units?|iu))$/i);
      if (match) {
        medName = match[1].trim();
        medStrength = match[2].trim();
      }
    }
  }

  return { medName, medStrength };

  
};


const [doseAmountError, setDoseAmountError] = useState(false);
const [frequencyError, setFrequencyError] = useState(false);
const [daysError, setDaysError] = useState(false);
const [routeError, setRouteError] = useState(false);
const [qtyError, setQtyError] = useState(false);


//Other Services

// --- Other Services: sample list ---

const [services, setservices] = useState([]);
const [serviceQuantities, setServiceQuantities] = useState({});

const loadOtherServices = async () => {
   setLoading(true);
  try {
    const response = await axios.get(loadOtherServicesdb, {
      params: {
        charge_status: "Manual",
      }
    });

    if (response.data.success) {
      setservices(response.data.results);
    } else {
      setservices([]);
    }

  } catch (error) {
    console.error("Failed to load other services:", error);
    setservices([]);
  }finally {
    setLoading(false);
  }
};


// Search
const [serviceSearchTerm, setServiceSearchTerm] = useState("");

// Requested Services
const [requestedServices, setRequestedServices] = useState([]);

const loadrequestedServices = async () => {
   setLoading(false);
  try {
    const response = await axios.get(loadRequestedOtherServicesInpatient, {
      params: { patientId: selectedPatient.id , dat:selectedPatient.visitDate, currentDate }
    });

    if (response.data.success) {
      setRequestedServices(response.data.results);
    }
  } catch (err) {
    console.error("Error loading meds:", err);
  }finally {
    setLoading(false);
  }
};


const handleManualServiceRequest = async () => {
  if (!manualServiceName || !manualAmount) {
    ErrorMessage("Missing info", "Enter service name and amount");
    return;
  }

  // prevent duplicate same-day request
  const existsToday = requestedServices.some(
    r => r.service.toLowerCase() === manualServiceName.toLowerCase()
  );

  if (existsToday) {
    ErrorMessage("Already Requested", "Service already requested today");
    return;
  }

  setLoading(true);

  try {
    const response = await axios.post(requestOtherService, {
      patientId: selectedPatient.id,
      dat: selectedPatient.visitDate,
      charge: manualServiceName,
      amount: Number(manualAmount) * Number(manualQty),
      doc_name: currentUser,
      from_user: currentUser,
      name: selectedPatient.fullName,
      department: "Doctor"
    });

    if (response.data.success) {
      loadrequestedServices();

      // clear fields
      setManualServiceName("");
      setManualQty(1);
      setManualAmount("");
    }
  } catch (err) {
    ErrorMessage("Error", "Failed to request service");
  } finally {
    setLoading(false);
  }
};



// Pagination
const [servicePage, setServicePage] = useState(0);
const [serviceRowsPerPage, setServiceRowsPerPage] = useState(10);
const [reqServicePage, setReqServicePage] = useState(0);
const [reqServiceRowsPerPage, setReqServiceRowsPerPage] = useState(10);


// Request a service (prevents duplicate request on the same day)
const handleRequestService = async(srv) => {

  console.log(requestedServices)

    const alreadyRequested = requestedServices.some(
    (r) => r.service === srv.name && r.date == currentDate
  );


  if (alreadyRequested) {
    const result = await Swal.fire({
      title: "Duplicate Request",
      text: `${srv.name} has already been requested today. Do you want to request again?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Request Again",
      cancelButtonText: "No"
    });

    if (!result.isConfirmed) {
       setLoading(false);
      return; // user cancelled
    }
  }

   setLoading(true);
    try {
    const response = await axios.post(requestOtherService, {
      patientId: selectedPatient.id,
      dat:currentDate,
      charge: srv.name,
      amount: srv.amount,
      doc_name:currentUser,
      from_user:currentUser,
      name:selectedPatient.fullName,
      department:'Doctor'
    });

    if (response.data.success) {
      loadrequestedServices();
    }

  } catch (error) {
    ErrorMessage("Error", "Failed to request Non Insured Services ");
  }finally {
    setLoading(false);
  }

 // setRequestedServices((prev) => [...prev, newReq]);
}; 


// Delete a requested service (allowed only if Pending in UI)
const handleDeleteServiceRequest = async (req) => {
  // ✅ Confirm deletion first
 
   setLoading(true);
  const confirmDelete = await Swal.fire({
    title: "Delete Other Request?",
    text: `Are you sure you want to delete "${req.service}"?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
  });

  if (!confirmDelete.isConfirmed) {
    setLoading(false)
    return; 
  }

   try {
    const response = await axios.post(deleteOrReverseOtherServicedb, {
      patientId: selectedPatient.id,
      scanName: req.service,
      dat:currentDate,
      currentUser
    });

    // ✅ If backend returns reversal warning
    if (response.data.reversal) {
      ErrorMessage("REVERSAL REQUIRED", response.data.reversal);
    } else {
      Swal.fire("Deleted", response.data.message, "success");
    }

    // ✅ Refresh the table
    loadrequestedServices();

  } catch (error) {
    Swal.fire("Error", "Failed to delete Other request", "error");
  }finally {
    setLoading(false);
  }
};


// Appointment

const [editingAppointmentId, setEditingAppointmentId] = useState(null);

// Load appointments
const [appointments, setAppointments] = useState([]);

const loadAppointments = async () => {
  try {
     setLoading(true);
    const response = await axios.get(loadAppointmentsdb, {
      params: { 
        patientId: selectedPatient?.id,
        doctorName: currentUser 
      }
    });

    if (response.data.success) {
      console.log(response.data.appointments)
      setAppointments(response.data.appointments || []);
    }
  } catch (error) {
    console.error("Error loading appointments:", error);
    ErrorMessage("Error", "Failed to load appointments");
  }finally {
    setLoading(false);
  }
};

// Save appointment
const handleSaveAppointment = async () => {
  if (!selectedPatient || !appointmentDate || !appointmentTime || !appointmentType) {
    ErrorMessage("Error", "Please complete all required fields.");
    return;
  }

   setLoading(true);
  try {
    if (editingAppointmentId) {
      // Update existing appointment
      const response = await axios.post(updateAppointmentdb, {
        appointmentId: editingAppointmentId,
        appointmentDate,
        appointmentTime,
        appointmentType,
        reason: appointmentReason,
        otherInfo: appointmentOther,
        sendReminder
      });

      if (response.data.success) {
        successMessage("Success", "Appointment updated successfully");
        loadAppointments();
        handleClearAppointmentForm();
      } else {
        ErrorMessage("Error", response.data.message);
      }
    } else {
      // Create new appointment
      const response = await axios.post(saveAppointmentdb, {
        patientId: selectedPatient.id,
        patientName: selectedPatient.fullName,
        patientTel: selectedPatient.tel,
        appointmentDate,
        appointmentTime,
        appointmentType,
        reason: appointmentReason,
        otherInfo: appointmentOther,
        sendReminder,
        currentUser
      });

      if (response.data.success) {
        successMessage("Success", "Appointment saved successfully");
        loadAppointments();
       // handleClearAppointmentForm();

        //if (sendReminder) {
        //  alert(
           // `Reminder sent to ${selectedPatient.fullName} for ${appointmentDate} at ${appointmentTime}.`
         // );
       // }
      } else {
        ErrorMessage("Error", response.data.message);
      }
    }
  } catch (error) {
    console.error("Error saving appointment:", error);
    ErrorMessage("Error", "Failed to save appointment");
  }finally {
    setLoading(false);
  }
};

// Clear form
const handleClearAppointmentForm = () => {
  setAppointmentDate("");
  setAppointmentTime("");
  setAppointmentType("");
  setAppointmentReason("");
  setAppointmentOther("");
  setSendReminder(false);
  setEditingAppointmentId(null);
};


// Delete appointment
const handleDeleteAppointment = async (editingAppointmentId) => {
  
  if (!editingAppointmentId) return;

  const confirmDelete = await Swal.fire({
    title: "Delete Appointment?",
    text: `Are you sure you want to delete this appointment for ${editingAppointmentId}?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
  });

  if (!confirmDelete.isConfirmed) return;

   setLoading(true);
  try {
    const response = await axios.post(deleteAppointmentdb, {
      appointmentId: editingAppointmentId
    });

    if (response.data.success) {
      Swal.fire("Deleted", response.data.message, "success");
      loadAppointments();
      handleClearAppointmentForm()
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Error deleting appointment:", error);
    ErrorMessage("Error", "Failed to delete appointment");
  }finally {
    setLoading(false);
  }
};


const loadPatientAppointments = async () => {
  setLoading(true);
  try {
    const res = await axios.get(getPatientAppointmentdb, {
      params: { patientId: selectedPatient.id }
    });

    if (res.data.success) {
      const allAppointments = res.data.appointments || [];

      // Update list stored in state
      setAppointments(allAppointments);

      // If no upcoming appointment → reset form
      if (allAppointments.length === 0) {
        setAppointmentDate("");
        setAppointmentTime("");
        setAppointmentType("");
        setAppointmentReason("");
        setAppointmentOther("");
        setSendReminder(false);
        setEditingAppointmentId(null);
        return;
      }

      // Get the nearest appointment
      const nextAppointment = allAppointments[0];

      setAppointmentDate(nextAppointment.date);
      setAppointmentTime(nextAppointment.time);
      setAppointmentType(nextAppointment.type);
      setAppointmentReason(nextAppointment.reason || "");
      setAppointmentOther(nextAppointment.other_info || "");
      setSendReminder(nextAppointment.send_reminder === 1);
      setEditingAppointmentId(nextAppointment.id);

      console.log("Loaded appointment:", nextAppointment);
    }
  } catch (error) {
    ErrorMessage("Error loading appointments:", error);
  }finally {
    setLoading(false);
  }
};

const [selectedDiagnoses, setSelectedDiagnoses] = useState([]);
const [selectedProcedures, setSelectedProcedures] = useState([]);
const [admissionStatus, setAdmissionStatus] = useState("");



const [appointmentDate, setAppointmentDate] = useState("");
const [appointmentTime, setAppointmentTime] = useState("");
const [appointmentType, setAppointmentType] = useState("");
const [appointmentReason, setAppointmentReason] = useState("");
const [appointmentOther, setAppointmentOther] = useState("");
const [sendReminder, setSendReminder] = useState(false);

// Unified search
const [filterSearch, setFilterSearch] = useState("");


//admit
const [admissionDate, setAdmissionDate] = useState(() => new Date().toISOString().split("T")[0]);
const [admissionTime, setAdmissionTime] = useState(() => {
  const now = new Date();
  return now.toTimeString().slice(0, 5);
});
const [admissionNote, setAdmissionNote] = useState("");
const [treatmentPlan, setTreatmentPlan] = useState("");

// The useState initialisers above only run once — on the very first mount of
// this component. If the doctor stays logged in and admits several patients
// through the day (or works past midnight), those "initial" values go stale
// and can even appear blank on some renders. Refreshing on every new patient
// selection means the admit form always opens with the actual current date
// and time, without the doctor having to log out and back in.
useEffect(() => {
  if (!selectedPatient?.id) return;
  const now = new Date();
  setAdmissionDate(now.toISOString().split("T")[0]);
  setAdmissionTime(now.toTimeString().slice(0, 5));
}, [selectedPatient?.id]);


const validateAdmissionForm = () => {

 

  if (!admissionDate) {
    ErrorMessage("Missing Field", "Please select Date ");
    return false;
  }

  if (!admissionTime) {
    ErrorMessage("Missing Field", "Please select Time ");
    return false;
  }

  if (!admissionNote.trim()) {
    ErrorMessage("Missing Field", "Note cannot be empty");
    return false;
  }

  return true;
};


const submitAdmission = async () => {
  setLoading(true);
  try {

     const result = await Swal.fire({
        title: "Discharge Patient",
        text: `Are you sure you want to discharge ${selectedPatient.fullName} of ID: ${selectedPatient.id} ?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Request Again",
        cancelButtonText: "No"
      });
  
      if (!result.isConfirmed) {
        setLoading(false);
        return; // user cancelled
      }

    const res = await axios.post(DischargePatient, {
      patientId: selectedPatient.id,
      name:selectedPatient.fullName ,
      age:selectedPatient.age ,
      gender:selectedPatient.gender,
      admissionStatus,
      admissionDate,
      admissionTime,
      admissionNote,
      dat:currentDate,
      visitDate:selectedPatient.visitDate,
      currentUser
    });

    if (res.data.success) {
      Swal.fire({
        icon: "success",
        title: "Patient Discharge",
        text: "Patient Discharge successfully."
      });

      // Optional: Reset form after success
      setAdmissionStatus("");


      setAdmissionNote("");
      setTreatmentPlan("");
      setActiveTab(0);
       loadPatients()
       clearSelectedPatientData()
    } else {
      Swal.fire("Error", res.data.message, "error");
    }

  } catch (err) {
    const data = err.response?.data;
    if (err.response?.status === 409 && data?.blocked && Array.isArray(data.incompleteDays)) {
      const minV = data.minVitalsPerDay ?? data.minPerDay ?? 3;
      const minN = data.minNotesPerDay  ?? 1;
      const rows = data.incompleteDays.map(d => {
        const vColor = d.missingVitals === 0 ? '#41a386' : '#b91c1c';
        const nColor = d.missingNotes  === 0 ? '#41a386' : '#b91c1c';
        const dayMinV = d.minVitals ?? minV;
        const dayMinN = d.minNotes  ?? minN;
        const missing = [];
        if (d.missingVitals > 0) missing.push(`${d.missingVitals} vital${d.missingVitals === 1 ? '' : 's'}`);
        if (d.missingNotes  > 0) missing.push(`${d.missingNotes} note${d.missingNotes === 1 ? '' : 's'}`);
        return `
          <div style="display:flex;align-items:center;gap:8px;padding:6px 10px;border:1px solid #e5e9ef;border-radius:6px;background:#f8fafc;margin:4px 0;">
            <span style="font-weight:700;color:#0f172a;min-width:96px;">${d.date}</span>
            <span style="font-size:12px;font-weight:600;color:${vColor};">Vitals ${d.vitals}/${dayMinV}</span>
            <span style="font-size:12px;font-weight:600;color:${nColor};">Notes ${d.notes}/${dayMinN}</span>
            ${missing.length ? `<span style="font-size:12px;color:#64748b;font-style:italic;">missing: ${missing.join(', ')}</span>` : ''}
          </div>`;
      }).join('');
      Swal.fire({
        icon: 'warning',
        title: 'Discharge Blocked — Compliance Not Met',
        html:
          `<p style="color:#475569;margin:0 0 8px;font-size:13px;">
             Every admission day must have at least <strong>${minV} vitals</strong> and <strong>${minN} nursing note${minN === 1 ? '' : 's'}</strong>.
             Ask the ward nurse to record the missing entries, then try discharge again.
           </p>
           <div style="text-align:left;max-height:240px;overflow-y:auto;">${rows}</div>`,
        confirmButtonText: 'OK, I will follow up',
        confirmButtonColor: '#41a386',
        width: 560,
      }).then(result => {
        if (result.isConfirmed && selectedPatient?.id && data.admissionDate) {
          axios.post(complianceFollowup, {
            patientId: selectedPatient.id,
            admissionDate: data.admissionDate,
            requestedBy: currentUser || null,
          }).catch(e => console.error('Failed to raise compliance follow-up:', e));
        }
      });
    } else {
      //  Same as the dialog path above: `data.message` is the fixed string, and
      //  `data.error` is the reason. See dischargeFailureHtml.
      Swal.fire({
        icon: 'error',
        title: 'Discharge failed',
        html: dischargeFailureHtml(data, err),
        confirmButtonColor: '#41a386',
        width: 540,
      });
      console.error('DischargePatient failed:', data || err);
    }
  }finally {
    setLoading(false);
  }
};


const submitdeath = async () => {
  setLoading(true);
  try {

     const result = await Swal.fire({
        title: "Dead Patient",
        text: `Are you sure This Patient Is Dead ${selectedPatient.fullName} of ID: ${selectedPatient.id} ?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Request Again",
        cancelButtonText: "No"
      });
  
      if (!result.isConfirmed) {
        setLoading(false);
        return; // user cancelled
      }

    const res = await axios.post(DeadchargePatient, {
      patientId: selectedPatient.id,
      name:selectedPatient.fullName ,
      age:selectedPatient.age ,
      gender:selectedPatient.gender,
      admissionStatus,
      admissionDate,
      admissionTime,
      admissionNote,
      dat:currentDate,
      visitDate:selectedPatient.visitDate,
      currentUser
    });

    if (res.data.success) {
      Swal.fire({
        icon: "success",
        title: "Patient Discharge",
        text: "Patient Discharge successfully."
      });

      // Optional: Reset form after success
      setAdmissionStatus("");
    
      
      setAdmissionNote("");
      setTreatmentPlan("");
      setActiveTab(0);
       loadPatients()
       clearSelectedPatientData()
    } else {
      Swal.fire("Error", res.data.message, "error");
    }

  } catch (err) {
    Swal.fire("Error", "Failed to Discharge patient.", "error");
    console.error(err);
  }finally {
    setLoading(false);
  }
};

const clearSelectedPatientData = () => {
  setSelectedPatient(null);
  setSearchTerm("");
  setSearchOpen(false);
  setSearchResults([]);
  setActiveTab(0);

  // Clear diagnosis fields
  setComplaint("");
  setHistory("");
  setExam("");
  setOther("");
  setSelectedDiagnoses([]);
  setSelectedProcedures([]);
  setHasLoadedDiagnosis(false);
  setHasEdited(false);

  // Clear services
  setServiceProvided("");
  setAttendanceType("");

  // Clear labs
  setLabs([]);
  setRequestedLabs([]);

  // Clear scans
  setscans([]);
  setRequestedScans([]);

  // Clear medications
  setMedications([]);
  setRequestedMeds([]);
  setSelectedMed(null);
  setDose("");
  setFrequency("");
  setDays("");
  setQty(0);
  setRoute("");

  // Clear appointments
  setAppointments([]);
  setAppointmentDate("");
  setAppointmentTime("");
  setAppointmentType("");
  setAppointmentReason("");
  setAppointmentOther("");
  setSendReminder(false);
  setEditingAppointmentId(null);

  // Clear other services
  setservices([]);
  setRequestedServices([]);

  console.log("All patient data cleared!");
};


const [wardRoundsOpen, setWardRoundsOpen] = useState(false);
const [wardRoundsData, setWardRoundsData] = useState([]);


const loadWardRoundsData = async () => {
  if (!selectedPatient) return;

  try {
    const res = await axios.get(loadWardRoundsdb, {
      params: {
        patientId: selectedPatient.id,
        startDate: selectedPatient.visitDate   // admission date
      }
    });

    if (res.data.success) {
      setWardRoundsData(res.data.data);
    }
  } catch (error) {
    console.error("Error loading ward rounds:", error);
  }
};


const handleWardRoundsClose = () => {
  setWardRoundsOpen(false);

  // 🔄 Reload patients list
  loadPatients();

  // 🔄 Reload selected patient full data
  if (selectedPatient) {
    loadInsuredServices(selectedPatient.insurance, selectedPatient.age);
    loadPatientDiagnosis(selectedPatient.id, selectedPatient.visitDate);
    loadServiceAndAttendance(selectedPatient.id, selectedPatient.visitDate);
    loadDiagnosisOptions(selectedPatient.age, selectedPatient.gender, selectedPatient.insurance);
    loadProcedureOptions(selectedPatient.age, selectedPatient.gender, selectedPatient.insurance);
    loadLabs();
    loadRequestedLabs();
    loadAvailableScans();
    loadRequestedScan();
    loadMedications();
    loadRequestedMeds();
    loadOtherServices();
    loadrequestedServices();
    loadPatientAppointments();
    loadWardRoundsData();
  }
};


  return (
    <Box sx={{
      bgcolor: "#f5f5f5", minHeight: "100vh", p: 1.5,
      // Density baseline — applies inside this view only.
      // Dialogs portal out of this tree, so they keep their own sizing.
      '& .MuiTypography-h4': { fontSize: '1.2rem' },
      '& .MuiTypography-h5': { fontSize: '1.05rem' },
      '& .MuiTypography-h6': { fontSize: '0.95rem', fontWeight: 700 },
      '& .MuiCardContent-root': { padding: '12px', '&:last-child': { paddingBottom: '12px' } },
      '& .MuiButton-sizeMedium': {
        paddingTop: '4px', paddingBottom: '4px',
        paddingLeft: '10px', paddingRight: '10px',
        fontSize: '0.78rem', minHeight: '30px',
      },
      '& .MuiButton-sizeSmall': {
        paddingTop: '2px', paddingBottom: '2px',
        paddingLeft: '8px', paddingRight: '8px',
        fontSize: '0.75rem', minHeight: '26px',
      },
      '& .MuiTab-root': { minHeight: 38 },
      '& .MuiTabs-root': { minHeight: 38 },
    }}>
      {loading && (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          bgcolor: "rgba(0,0,0,0.4)",
          backdropFilter: "blur(2px)",
          zIndex: 2000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <CircularProgress size={70} thickness={5} />
      </Box>
)}

      <Container maxWidth="xl">
        {/* ── DETENTION REVIEWS DUE — floating pill (top-right) + dialog ── */}
        {!selectedPatient && reviewsDue.length > 0 && (
          <Tooltip
            title={`${reviewsDue.length} detention${reviewsDue.length === 1 ? '' : 's'} need${reviewsDue.length === 1 ? 's' : ''} review`}
            arrow
            placement="left"
          >
            <Box
              role="button"
              onClick={() => setReviewsDialogOpen(true)}
              sx={{
                position: 'fixed',
                top: 88,
                right: 24,
                zIndex: 1100,
                bgcolor: '#1A9B7F',
                color: '#fff',
                borderRadius: 999,
                pl: 1.25, pr: 2,
                py: 0.85,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                boxShadow: '0 6px 20px rgba(26,155,127,0.35)',
                transition: 'transform .18s ease, box-shadow .18s ease, background-color .18s ease',
                '&:hover': {
                  bgcolor: '#157763',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 10px 26px rgba(26,155,127,0.45)',
                },
                animation: 'reviewsPulse 2.4s ease-in-out infinite',
                '@keyframes reviewsPulse': {
                  '0%, 100%': { boxShadow: '0 6px 20px rgba(26,155,127,0.35)' },
                  '50%':      { boxShadow: '0 6px 24px rgba(26,155,127,0.55)' },
                },
              }}
            >
              <Box sx={{
                width: 26, height: 26, borderRadius: '50%',
                bgcolor: 'rgba(255,255,255,0.18)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0,
              }}>
                <WarningAmber sx={{ fontSize: 16, color: '#fff' }} />
              </Box>
              <Typography sx={{ fontSize: '0.78rem', fontWeight: 700, letterSpacing: 0.4, textTransform: 'uppercase' }}>
                {reviewsDue.length} Review{reviewsDue.length === 1 ? '' : 's'} Due
              </Typography>
            </Box>
          </Tooltip>
        )}

        {/* ── DETENTION REVIEWS DUE — dialog ── */}
        <Dialog
          open={reviewsDialogOpen}
          onClose={() => setReviewsDialogOpen(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden' } }}
        >
          {/* Header — system-teal gradient */}
          <Box sx={{
            px: 3, py: 2.25,
            background: 'linear-gradient(135deg, #1A9B7F 0%, #157763 100%)',
            color: '#fff',
            display: 'flex', alignItems: 'center', gap: 1.5,
          }}>
            <Box sx={{
              width: 40, height: 40, borderRadius: 2,
              bgcolor: 'rgba(255,255,255,0.18)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0,
            }}>
              <WarningAmber sx={{ fontSize: 22, color: '#fff' }} />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={{
                fontSize: '0.65rem', fontWeight: 700,
                letterSpacing: '1.4px', textTransform: 'uppercase',
                opacity: 0.85, lineHeight: 1.2,
              }}>
                Decision Required
              </Typography>
              <Typography sx={{ fontWeight: 700, fontSize: '1.1rem', lineHeight: 1.25 }}>
                Detention Reviews
              </Typography>
              <Typography sx={{ fontSize: '0.82rem', opacity: 0.92, mt: 0.25 }}>
                {reviewsDue.length} patient{reviewsDue.length === 1 ? '' : 's'} reached the 24-hour observation window
              </Typography>
            </Box>
            <IconButton
              size="small"
              onClick={() => setReviewsDialogOpen(false)}
              sx={{
                color: '#fff',
                bgcolor: 'rgba(255,255,255,0.15)',
                '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' },
              }}
            >
              <Close fontSize="small" />
            </IconButton>
          </Box>

          {/* Optional helper bar */}
          <Box sx={{
            px: 3, py: 1.5,
            bgcolor: '#f8fafc',
            borderBottom: '1px solid #e5e9ef',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            flexWrap: { xs: 'wrap', sm: 'nowrap' },
          }}>
            <Typography sx={{ fontSize: '0.78rem', color: '#475569', flex: 1, minWidth: 200 }}>
              Choose an action for each patient — open the chart to review, or convert their detention into a full admission.
            </Typography>
            <TextField
              size="small"
              placeholder="Search by name, ID, ward, bed, doctor…"
              value={reviewsSearch}
              onChange={(e) => setReviewsSearch(e.target.value)}
              sx={{
                width: { xs: '100%', sm: 280 },
                '& .MuiOutlinedInput-root': {
                  borderRadius: 1.5,
                  bgcolor: '#fff',
                  fontSize: '0.85rem',
                  '& fieldset': { borderColor: '#e5e9ef' },
                  '&:hover fieldset': { borderColor: '#1A9B7F' },
                  '&.Mui-focused fieldset': { borderColor: '#1A9B7F', borderWidth: 1.5 },
                  '&.Mui-focused': { boxShadow: '0 0 0 4px rgba(26,155,127,0.10)' },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search sx={{ fontSize: 18, color: '#94a3b8' }} />
                  </InputAdornment>
                ),
                endAdornment: reviewsSearch && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => setReviewsSearch('')} sx={{ color: '#94a3b8' }}>
                      <Close fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          <DialogContent sx={{ p: 1.25, maxHeight: '62vh', bgcolor: '#fff' }}>
            {reviewsDue.length === 0 ? (
              <Box sx={{ py: 6, textAlign: 'center' }}>
                <Typography sx={{ color: '#64748b' }}>No reviews currently due.</Typography>
              </Box>
            ) : filteredReviewsDue.length === 0 ? (
              <Box sx={{ py: 6, textAlign: 'center' }}>
                <Search sx={{ fontSize: 32, color: '#cbd5e1', mb: 1 }} />
                <Typography sx={{ color: '#64748b', fontSize: '0.9rem' }}>
                  No patients match "{reviewsSearch}".
                </Typography>
              </Box>
            ) : filteredReviewsDue.map((p) => (
              <Box
                key={p.id}
                sx={{
                  display: 'flex', alignItems: 'center', gap: 1.5,
                  px: 1.75, py: 1.5,
                  borderRadius: 2,
                  borderBottom: '1px solid #f1f5f9',
                  '&:last-child': { borderBottom: 'none' },
                  transition: 'background-color .15s ease',
                  '&:hover': { bgcolor: 'rgba(26,155,127,0.04)' },
                }}
              >
                <Box sx={{
                  width: 40, height: 40, borderRadius: 1.75,
                  bgcolor: 'rgba(26,155,127,0.12)',
                  color: '#1A9B7F',
                  fontWeight: 700, fontSize: 13,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  flexShrink: 0,
                }}>
                  {(p.fullName || '?').split(/\s+/).slice(0,2).map(s => s[0]).join('').toUpperCase()}
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography sx={{ fontWeight: 700, fontSize: '0.92rem', color: '#0f172a', lineHeight: 1.3 }}>
                    {p.fullName}
                    <Box component="span" sx={{ ml: 1, fontWeight: 500, color: '#64748b', fontSize: '0.78rem' }}>
                      · ID {p.id}{p.age != null ? ` · ${p.age} yrs` : ''}{p.gender ? ` · ${p.gender}` : ''}
                    </Box>
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5, flexWrap: 'wrap' }}>
                    <Chip
                      size="small"
                      label={`${p.hours_detained ?? 0}h detained`}
                      sx={{
                        height: 20, fontSize: '0.7rem', fontWeight: 700,
                        bgcolor: '#fee2e2', color: '#b91c1c',
                        '& .MuiChip-label': { px: 1 },
                      }}
                    />
                    {p.ward_name && (
                      <Typography sx={{ fontSize: '0.75rem', color: '#64748b' }}>
                        · {p.ward_name}
                      </Typography>
                    )}
                    {p.bed_number && (
                      <Typography sx={{ fontSize: '0.75rem', color: '#64748b' }}>
                        · Bed {p.bed_number}
                      </Typography>
                    )}
                    {p.detaining_doctor && (
                      <Typography sx={{ fontSize: '0.75rem', color: '#64748b' }}>
                        · by {p.detaining_doctor}
                      </Typography>
                    )}
                  </Box>
                </Box>
                <Stack direction="row" spacing={0.75} sx={{ flexShrink: 0 }}>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => {
                      setReviewsDialogOpen(false);
                      clearSelectedPatientData();
                      setSelectedPatient(p);
                    }}
                    sx={{
                      textTransform: 'none', fontWeight: 600,
                      borderColor: '#e5e9ef', color: '#475569',
                      '&:hover': { borderColor: '#1A9B7F', color: '#1A9B7F', bgcolor: 'rgba(26,155,127,0.06)' },
                    }}
                  >
                    Open Chart
                  </Button>
                  <Button
                    size="small"
                    variant="contained"
                    onClick={() => handleConvertToAdmission(p)}
                    sx={{
                      textTransform: 'none', fontWeight: 600,
                      bgcolor: '#1A9B7F',
                      boxShadow: 'none',
                      '&:hover': { bgcolor: '#157763', boxShadow: '0 4px 12px rgba(26,155,127,0.25)' },
                    }}
                  >
                    Convert to Admission
                  </Button>
                </Stack>
              </Box>
            ))}
          </DialogContent>
        </Dialog>

        {/* ── DISCHARGE DIALOG — same data path as the Discharge tab, presented as a modal ── */}
        <Dialog
          open={dischargeDialogOpen}
          onClose={dischargingNow ? undefined : () => setDischargeDialogOpen(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden' } }}
        >
          {/* Header */}
          <Box sx={{
            px: 3, py: 2.25,
            background: 'linear-gradient(135deg, #1A9B7F 0%, #157763 100%)',
            color: '#fff',
            display: 'flex', alignItems: 'center', gap: 1.5,
          }}>
            <Box sx={{
              width: 40, height: 40, borderRadius: 2,
              bgcolor: 'rgba(255,255,255,0.18)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0,
            }}>
              <Hotel sx={{ fontSize: 22, color: '#fff' }} />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={{
                fontSize: '0.65rem', fontWeight: 700,
                letterSpacing: '1.4px', textTransform: 'uppercase',
                opacity: 0.85, lineHeight: 1.2,
              }}>
                {selectedPatient?.status === 'Detention' ? 'Detention Discharge' : 'Patient Discharge'}
              </Typography>
              <Typography sx={{ fontWeight: 700, fontSize: '1.05rem', lineHeight: 1.25, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {selectedPatient?.fullName}
                <Box component="span" sx={{ ml: 1, fontWeight: 500, opacity: 0.85, fontSize: '0.85rem' }}>
                  · ID {selectedPatient?.id}
                </Box>
              </Typography>
            </Box>
            <IconButton
              size="small"
              onClick={() => !dischargingNow && setDischargeDialogOpen(false)}
              disabled={dischargingNow}
              sx={{
                color: '#fff',
                bgcolor: 'rgba(255,255,255,0.15)',
                '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' },
              }}
            >
              <Close fontSize="small" />
            </IconButton>
          </Box>

          {/* Detention notice (waived ward fees) */}
          {selectedPatient?.status === 'Detention' && (
            <Box sx={{
              px: 3, py: 1.25,
              bgcolor: 'rgba(26,155,127,0.08)',
              borderBottom: '1px solid rgba(26,155,127,0.20)',
              display: 'flex', alignItems: 'center', gap: 1,
            }}>
              <WarningAmber sx={{ fontSize: 18, color: '#1A9B7F' }} />
              <Typography sx={{ fontSize: '0.8rem', color: '#0f4f3f', fontWeight: 500 }}>
                <Box component="span" sx={{ fontWeight: 700 }}>Detention discharge:</Box>{' '}
                ward and bed user fees are waived for this patient.
              </Typography>
            </Box>
          )}

          <DialogContent sx={{ p: 3, bgcolor: '#fff', maxHeight: '70vh' }}>
            {/* Read-only summary — same chips the tab-6 form shows */}
            <Grid container spacing={2.5}>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: '#94a3b8', letterSpacing: '0.6px', textTransform: 'uppercase', mb: 0.75 }}>
                  Diagnoses
                </Typography>
                <Box sx={{ border: '1px solid #e5e9ef', borderRadius: 1.75, p: 1.25, minHeight: 60, bgcolor: '#f8fafc' }}>
                  {selectedDiagnoses && selectedDiagnoses.length > 0
                    ? selectedDiagnoses.map((d, i) => <Chip key={i} label={d.name} size="small" sx={{ m: 0.25 }} />)
                    : <Typography variant="caption" color="text.secondary">No diagnosis selected</Typography>}
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: '#94a3b8', letterSpacing: '0.6px', textTransform: 'uppercase', mb: 0.75 }}>
                  Procedures
                </Typography>
                <Box sx={{ border: '1px solid #e5e9ef', borderRadius: 1.75, p: 1.25, minHeight: 60, bgcolor: '#f8fafc' }}>
                  {selectedProcedures && selectedProcedures.length > 0
                    ? selectedProcedures.map((p, i) => <Chip key={i} label={p.name} size="small" sx={{ m: 0.25 }} />)
                    : <Typography variant="caption" color="text.secondary">No procedure selected</Typography>}
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: '#94a3b8', letterSpacing: '0.6px', textTransform: 'uppercase', mb: 0.75 }}>
                  Lab Requested
                </Typography>
                <Box sx={{ border: '1px solid #e5e9ef', borderRadius: 1.75, p: 1.25, minHeight: 60, bgcolor: '#f8fafc' }}>
                  {requestedLabs && requestedLabs.length > 0
                    ? requestedLabs.map((l, i) => <Chip key={i} label={l.lab} size="small" sx={{ m: 0.25 }} />)
                    : <Typography variant="caption" color="text.secondary">None</Typography>}
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: '#94a3b8', letterSpacing: '0.6px', textTransform: 'uppercase', mb: 0.75 }}>
                  Scan Requested
                </Typography>
                <Box sx={{ border: '1px solid #e5e9ef', borderRadius: 1.75, p: 1.25, minHeight: 60, bgcolor: '#f8fafc' }}>
                  {requestedScans && requestedScans.length > 0
                    ? requestedScans.map((s, i) => <Chip key={i} label={s.lab} size="small" sx={{ m: 0.25 }} />)
                    : <Typography variant="caption" color="text.secondary">None</Typography>}
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: '#94a3b8', letterSpacing: '0.6px', textTransform: 'uppercase', mb: 0.75 }}>
                  Medication Requested
                </Typography>
                <Box sx={{ border: '1px solid #e5e9ef', borderRadius: 1.75, p: 1.25, minHeight: 60, bgcolor: '#f8fafc' }}>
                  {requestedMeds && requestedMeds.length > 0
                    ? requestedMeds.map((m, i) => <Chip key={i} label={m.drug} size="small" sx={{ m: 0.25 }} />)
                    : <Typography variant="caption" color="text.secondary">None</Typography>}
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: '#94a3b8', letterSpacing: '0.6px', textTransform: 'uppercase', mb: 0.75 }}>
                  Other Services
                </Typography>
                <Box sx={{ border: '1px solid #e5e9ef', borderRadius: 1.75, p: 1.25, minHeight: 60, bgcolor: '#f8fafc' }}>
                  {requestedServices && requestedServices.length > 0
                    ? requestedServices.map((s, i) => <Chip key={i} label={s.service} size="small" sx={{ m: 0.25 }} />)
                    : <Typography variant="caption" color="text.secondary">None</Typography>}
                </Box>
              </Grid>

              {/* Date + time */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Date of Discharge"
                  type="date"
                  value={admissionDate}
                  disabled
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Time of Discharge"
                  type="time"
                  value={admissionTime}
                  onChange={(e) => setAdmissionTime(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* Discharge note */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline minRows={4}
                  label="Discharge Note"
                  placeholder="Final review note, condition on discharge, follow-up instructions, take-home medications, etc."
                  value={admissionNote}
                  onChange={(e) => setAdmissionNote(e.target.value)}
                  required
                />
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #e5e9ef', bgcolor: '#fafbfc' }}>
            <Button
              onClick={() => setDischargeDialogOpen(false)}
              disabled={dischargingNow}
              sx={{ textTransform: 'none', color: '#64748b' }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              startIcon={dischargingNow ? <CircularProgress size={16} color="inherit" /> : <Hotel />}
              onClick={handleDischargeFromDialog}
              disabled={dischargingNow}
              sx={{
                bgcolor: '#1A9B7F',
                textTransform: 'none', fontWeight: 600,
                px: 3,
                boxShadow: 'none',
                '&:hover': { bgcolor: '#157763', boxShadow: '0 4px 12px rgba(26,155,127,0.25)' },
                '&:disabled': { bgcolor: '#e5e9ef', color: '#94a3b8' },
              }}
            >
              {dischargingNow ? 'Discharging…' : 'Discharge Patient'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* ── PATIENT WORKLIST TABLE — shown when no patient is selected ── */}
        {!selectedPatient && (
          <PatientTable
            patients={allPatients}
            onSelectPatient={setSelectedPatient}
            currentUser={currentUser}
          />
        )}

        {/* ── PATIENT WORKSPACE — shown when a patient is selected ── */}
        {selectedPatient && (
        <>
        {/* Slim patient header bar with Back + Prev/Next */}
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2.5,
          flexWrap: 'wrap',
          gap: 2,
        }}>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Tooltip title="Back to patient list" arrow>
              <IconButton
                onClick={() => { setSelectedPatient(null); setSearchTerm(''); }}
                size="small"
                sx={{
                  bgcolor: 'rgba(26,155,127,0.10)',
                  color: '#1A9B7F',
                  '&:hover': { bgcolor: 'rgba(26,155,127,0.18)' },
                }}
              >
                <ArrowBack sx={{ fontSize: 18 }} />
              </IconButton>
            </Tooltip>
            <Box>
              <Typography sx={{
                fontSize: '0.7rem', fontWeight: 700,
                color: '#1A9B7F', letterSpacing: '1.2px', textTransform: 'uppercase',
              }}>
                InPatient Consultation
              </Typography>
              <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#0f172a', lineHeight: 1.25 }}>
                {selectedPatient.fullName}
                <Box component="span" sx={{ fontWeight: 500, color: '#64748b', fontSize: '0.85rem', ml: 1 }}>
                  · ID {selectedPatient.id}
                </Box>
              </Typography>
            </Box>
          </Stack>

          {currentPatientIndex >= 0 && allPatients.length > 1 && (
            <Stack
              direction="row"
              alignItems="center"
              spacing={0.5}
              sx={{
                bgcolor: '#fff',
                border: '1px solid #e5e9ef',
                borderRadius: 1.75,
                px: 0.5,
                py: 0.25,
              }}
            >
              <Tooltip title={hasPrevPatient ? 'Previous patient (←)' : 'No previous patient'} arrow>
                <span>
                  <IconButton
                    size="small"
                    onClick={goToPrevPatient}
                    disabled={!hasPrevPatient}
                    sx={{
                      color: '#1A9B7F',
                      '&.Mui-disabled': { color: '#cbd5e1' },
                      '&:hover': { bgcolor: 'rgba(26,155,127,0.10)' },
                    }}
                  >
                    <ArrowBackIosNew sx={{ fontSize: 14 }} />
                  </IconButton>
                </span>
              </Tooltip>

              <Box sx={{
                px: 1.25, minWidth: 78, textAlign: 'center',
                borderLeft: '1px solid #f1f5f9',
                borderRight: '1px solid #f1f5f9',
              }}>
                <Typography sx={{ fontSize: '0.85rem', fontWeight: 700, color: '#0f172a', lineHeight: 1.1 }}>
                  {currentPatientIndex + 1}
                  <Box component="span" sx={{ color: '#94a3b8', fontWeight: 500, mx: 0.4 }}>
                    of
                  </Box>
                  {allPatients.length}
                </Typography>
                <Typography sx={{ fontSize: '0.62rem', color: '#94a3b8', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                  Patient
                </Typography>
              </Box>

              <Tooltip title={hasNextPatient ? 'Next patient (→)' : 'No next patient'} arrow>
                <span>
                  <IconButton
                    size="small"
                    onClick={goToNextPatient}
                    disabled={!hasNextPatient}
                    sx={{
                      color: '#1A9B7F',
                      '&.Mui-disabled': { color: '#cbd5e1' },
                      '&:hover': { bgcolor: 'rgba(26,155,127,0.10)' },
                    }}
                  >
                    <ArrowForwardIos sx={{ fontSize: 14 }} />
                  </IconButton>
                </span>
              </Tooltip>
            </Stack>
          )}
        </Box>

        {/* ── Decision-required banner: shown when the selected patient is a
            detained case whose 24h observation has elapsed.
            Two clear actions: jump to the discharge form, or convert to admission. */}
        {isReviewDue && (
          <Paper
            elevation={0}
            sx={{
              mb: 2.5,
              p: 2,
              borderRadius: 2.5,
              border: '1px solid #fecaca',
              bgcolor: '#fef2f2',
              display: 'flex',
              alignItems: { xs: 'flex-start', md: 'center' },
              gap: 2,
              flexDirection: { xs: 'column', md: 'row' },
            }}
          >
            <Box sx={{
              width: 40, height: 40, borderRadius: 1.5,
              bgcolor: '#dc2626', color: '#fff',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0,
            }}>
              <EventBusy sx={{ fontSize: 22 }} />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography sx={{ fontWeight: 700, color: '#7f1d1d', fontSize: '0.95rem', lineHeight: 1.2 }}>
                Decision required — 24h detention has elapsed
              </Typography>
              <Typography sx={{ fontSize: '0.82rem', color: '#991b1b', mt: 0.25 }}>
                This patient has been under detention for {selectedHoursDetained}h. Please discharge or convert to a full admission to keep the workflow clean.
              </Typography>
            </Box>
            <Stack direction="row" spacing={1} sx={{ flexShrink: 0 }}>
              <Button
                variant="outlined"
                size="small"
                onClick={() => setDischargeDialogOpen(true)}
                sx={{
                  textTransform: 'none', fontWeight: 600,
                  borderColor: '#dc2626', color: '#dc2626',
                  '&:hover': { borderColor: '#991b1b', bgcolor: 'rgba(220,38,38,0.06)' },
                }}
              >
                Discharge
              </Button>
              <Button
                variant="contained"
                size="small"
                onClick={() => handleConvertToAdmission()}
                sx={{
                  textTransform: 'none', fontWeight: 600,
                  bgcolor: '#1A9B7F',
                  boxShadow: 'none',
                  '&:hover': { bgcolor: '#157763', boxShadow: '0 4px 12px rgba(26,155,127,0.25)' },
                }}
              >
                Convert to Admission
              </Button>
            </Stack>
          </Paper>
        )}

        {/* --- Patient Search Box --- */}
    <Paper sx={{ p: 2, mb: 3 }}>
      <Autocomplete
        fullWidth
        freeSolo
        open={searchOpen}
        onOpen={() => {
          if (searchResults.length > 0 && searchTerm.length > 0)
            setSearchOpen(true);
        }}
        onClose={() => setSearchOpen(false)}
        inputValue={searchTerm}
        onInputChange={(event, newInputValue) => {
          setSearchTerm(newInputValue);
          if (newInputValue.length < 1) {
            setSearchOpen(false);
            setSearchResults([]);
          }
        }}
        options={searchResults}
        loading={searchLoading}
        getOptionLabel={(option) => `${option.fullName} (${option.id})`}
        renderOption={(props, option) => (
          <Box
            component="li"
            {...props}
            onClick={() => {
              clearSelectedPatientData();
              setSelectedPatient(option);
              setSearchOpen(false);
            }}
            sx={{
              borderBottom: "1px solid",
              borderColor: "divider",
              "&:last-child": { borderBottom: "none" },
              p: 2,
              cursor: "pointer",
              "&:hover": { bgcolor: "action.hover" },
            }}
          >
            <Box display="flex" alignItems="center" gap={2} width="100%">
              <Avatar sx={{ bgcolor: "primary.main" }}>
                <Person />
              </Avatar>
              <Box flex={1}>
                <Typography variant="subtitle1" fontWeight="bold">
                  {option.fullName}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  ID: {option.id}
                </Typography>
                <Stack direction="row" spacing={1} sx={{ mt: 0.5 }}>
                  <Chip
                    size="small"
                    label={option.gender}
                    color={option.gender === "MALE" ? "info" : "error"}
                  />
                  <Chip size="small" label={option.insurance} />
                  <Chip
                    size="small"
                    label={option.state}
                    color={
                      option.state === "inPatient" ? "success" : "warning"
                    }
                  />
                </Stack>
              </Box>
              <Box textAlign="right">
                <Typography variant="body2" color="text.secondary">
                  {option.tel}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Age: {option.age}
                </Typography>
              </Box>
            </Box>
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Search patient by ID, Name"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <Search sx={{ color: "action.active", mr: 1 }} />
              ),
              endAdornment: (
                <>
                  {searchLoading ? (
                    <CircularProgress color="inherit" size={25} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Paper>

       
{/* Sentinel for the IntersectionObserver — drives auto collapse/expand */}
{selectedPatient && (
  <Box ref={bannerSentinelRef} sx={{ height: 1, mb: 0 }} />
)}

{/* Slim sticky strip — shown when banner is collapsed */}
{selectedPatient && bannerCollapsed && (
  <Box
    onClick={() => { setBannerCollapsed(false); setBannerManual(true); }}
    sx={{
      position: 'sticky', top: 0, zIndex: 50,
      mb: 1, mx: -1.5, px: 1.5, py: 0.75,
      bgcolor: '#fff', borderBottom: '1px solid #e5e9ef',
      boxShadow: '0 2px 6px rgba(15,23,42,0.04)',
      display: 'flex', alignItems: 'center', gap: 1.25,
      cursor: 'pointer', transition: 'background-color .15s ease',
      '&:hover': { bgcolor: '#f8fafc' },
    }}
  >
    <Avatar sx={{
      width: 28, height: 28, fontSize: 12, fontWeight: 700,
      bgcolor: '#1A9B7F', color: '#fff',
    }}>
      {(selectedPatient.fullName || '?').split(/\s+/).slice(0,2).map(s => s[0]).join('').toUpperCase()}
    </Avatar>
    <Typography sx={{ fontSize: '0.85rem', fontWeight: 700, color: '#0f172a', flex: 1, minWidth: 0 }} noWrap>
      {selectedPatient.fullName}
      <Box component="span" sx={{ color: '#64748b', fontWeight: 500, ml: 0.75 }}>· {selectedPatient.id}</Box>
    </Typography>
    <IconButton size="small" sx={{ color: '#1A9B7F' }}>
      <KeyboardArrowDown />
    </IconButton>
  </Box>
)}

{/* --- Enhanced Patient Info Card --- */}
{selectedPatient && (
  <Collapse in={!bannerCollapsed} timeout={220}>
  <Card
    sx={{
      mb: 1.5,
      boxShadow: '0 2px 10px rgba(15,23,42,0.06)',
      borderRadius: 2,
      overflow: 'hidden',
      position: 'relative',
      opacity: selectedPatient.state === 'Discharge' ? 0.6 : 1,
      pointerEvents: selectedPatient.state === 'Discharge' ? 'none' : 'auto'
    }}
  >
    {/* Manual collapse toggle — top-right of the banner */}
    <IconButton
      size="small"
      onClick={() => { setBannerCollapsed(true); setBannerManual(true); }}
      sx={{
        position: 'absolute', top: 6, right: 6, zIndex: 6,
        bgcolor: 'rgba(15,23,42,0.04)', color: '#475569',
        '&:hover': { bgcolor: 'rgba(15,23,42,0.10)' },
      }}
    >
      <KeyboardArrowUp />
    </IconButton>
    {/* Discharge Overlay */}
    {selectedPatient.state === 'Discharge' && (
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: 'rgba(0, 0, 0, 0.05)',
          zIndex: 10,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          pointerEvents: 'auto'
        }}
      >
        <LockIcon sx={{ fontSize: 120, color: 'error.main', opacity: 0.8 }} />
        <Typography variant="h4" fontWeight={700} color="error.main">
          PATIENT DISCHARGED
        </Typography>
        <Typography variant="h6" color="text.secondary">
          This patient was discharged and records are locked
        </Typography>
        <Button
          variant="contained"
          color="success"
          size="large"
          startIcon={<PersonAdd />}
          onClick={handleReAdmitPatient}
          sx={{
            mt: 2,
            px: 4,
            py: 1.5,
            fontSize: '1.1rem',
            fontWeight: 600,
            boxShadow: '0 4px 15px rgba(76, 175, 80, 0.4)',
            '&:hover': {
              boxShadow: '0 6px 20px rgba(76, 175, 80, 0.6)',
              transform: 'translateY(-2px)',
              transition: 'all 0.3s ease'
            }
          }}
        >
          Re-Admit Patient
        </Button>
      </Box>
    )}

    {/* Header Section with Gradient Background */}
    <Box
      sx={{
        p: 1.5,
        borderBottom: '1px solid',
        borderColor: 'rgba(26,155,127,0.30)',
        bgcolor: '#f8fafc'
      }}
    >
      <Grid container spacing={1.5} alignItems="flex-start" columns={{ xs: 4, sm: 8, md: 12 }}>
        {/* Patient Biodata */}
        <Grid item xs={12} md={3} size={4}>
          <Box display="flex" alignItems="center" gap={1.25}>
            <Avatar
              sx={{
                bgcolor: 'white',
                color: 'primary.main',
                width: 44,
                height: 44,
                fontSize: 16,
                fontWeight: 700,
                boxShadow: '0 2px 8px rgba(0,0,0,0.10)'
              }}
            >
              {selectedPatient.fullName
                .split(" ")
                .map((n) => n[0])
                .join("")
                .slice(0, 2)}
            </Avatar>
            <Box>
              <Typography sx={{ fontSize: '0.95rem', fontWeight: 700, color: '#0f172a', lineHeight: 1.2 }}>
                {selectedPatient.fullName}
              </Typography>
              <Typography sx={{ fontSize: '0.75rem', color: '#64748b', mt: 0.25, mb: 0.5 }}>
                {selectedPatient.age} yrs · ID {selectedPatient.id}
              </Typography>
              <Stack direction="row" spacing={1}>
                <Chip
                  size="small"
                  label={selectedPatient.gender}
                  sx={{
                    bgcolor: selectedPatient.gender === "MALE" 
                      ? 'rgba(33, 150, 243, 0.9)' 
                      : 'rgba(244, 67, 54, 0.9)',
                    color: 'white',
                    fontWeight: 600
                  }}
                />
                <Chip
                  size="small"
                  label={selectedPatient.insurance}
                  sx={{ 
                    bgcolor: 'rgba(255, 152, 0, 0.9)', 
                    color: 'white',
                    fontWeight: 600,
                    
                  }}
                />
              </Stack>
              
              <Button
                variant="contained"
                startIcon={<LocalHospital />}
                fullWidth
                sx={{
                  mt: 4,
                  background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
                  color: "white",
                  px: 3,
                  py: 1.5,
                  fontSize: "1rem",
                  fontWeight: 600,
                  borderRadius: 3,
                  textTransform: "none",
                  boxShadow: "0 4px 15px rgba(17, 153, 142, 0.4)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: "linear-gradient(135deg, #38ef7d 0%, #11998e 100%)",
                    boxShadow: "0 6px 20px rgba(17, 153, 142, 0.6)",
                    transform: "translateY(-2px)"
                  },
                  "&:active": {
                    transform: "translateY(0px)"
                  }
                }}
                onClick={() => setWardRoundsOpen(true)}
              >
                Ward Rounds / Information
              </Button>

            </Box>
          </Box>
        </Grid>

        {/* Contact & Visit Information */}
        <Grid item xs={12} md={3} size={3} >
          <Stack spacing={1.5}>
            <Box>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                Contact Information
              </Typography>
              <Typography variant="body1" fontWeight={500}>
                📞 {selectedPatient.tel}
              </Typography>
              <Typography variant="body1" fontWeight={500}>
                📍 {selectedPatient.location}
              </Typography>
            </Box>
            
            <Box>
  {/* Show detention badge with countdown if in detention, otherwise show regular chip */}
  {selectedPatient.status === 'Detention' ? (
    (() => {
      const detentionStart = moment(selectedPatient.currtime);
      const now = moment();
      const detentionEnd = detentionStart.clone().add(30, 'hours');
      const totalDuration = 30 * 60; // 30 hours in minutes
      const elapsed = now.diff(detentionStart, 'minutes');
      const percentage = Math.min(100, (elapsed / totalDuration) * 100);

      return (
        <Box
          sx={{
            mb: 2,
            bgcolor: 'warning.main',
            color: 'white',
            px: 2,
            py: 1.5,
            borderRadius: 2,
            boxShadow: '0 4px 12px rgba(255, 152, 0, 0.4)',
            animation: 'pulse 2s ease-in-out infinite',
            '@keyframes pulse': {
              '0%, 100%': {
                boxShadow: '0 4px 12px rgba(255, 152, 0, 0.4)',
              },
              '50%': {
                boxShadow: '0 4px 20px rgba(255, 152, 0, 0.7)',
              }
            }
          }}
        >
          {/* Header */}
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Box display="flex" alignItems="center" gap={1}>
              <LockIcon sx={{ fontSize: 20 }} />
              <Typography variant="subtitle2" fontWeight={700} sx={{ letterSpacing: 0.5 }}>
                🔒 DETENTION
              </Typography>
            </Box>
            
            {detentionTimeLeft && (
              <Typography 
                variant="caption" 
                fontWeight={600}
                sx={{ 
                  fontFamily: 'monospace',
                  bgcolor: 'rgba(0, 0, 0, 0.2)',
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 1,
                  fontSize: '0.75rem'
                }}
              >
                {detentionTimeLeft === 'EXPIRED' ? '⚠️ EXPIRED' : `⏱️ ${detentionTimeLeft}`}
              </Typography>
            )}
          </Box>

          {/* Progress Bar */}
          <Box sx={{ width: '100%', bgcolor: 'rgba(0, 0, 0, 0.2)', borderRadius: 1, height: 6 }}>
            <Box
              sx={{
                width: `${percentage}%`,
                bgcolor: percentage > 90 ? 'error.main' : percentage > 70 ? 'warning.light' : '#4caf50',
                height: '100%',
                borderRadius: 1,
                transition: 'all 0.5s ease'
              }}
            />
          </Box>
        </Box>
      );
    })()
  ) : (
    <Chip
      label={selectedPatient.status}
      sx={{ 
        bgcolor: 'rgba(255, 193, 7, 0.9)',
        color: 'white',
        fontWeight: 600,
        mb: 1
      }}
    />
  )}
  
  <Typography variant="body2" sx={{ fontWeight: 600 }}>
    Visit Date: {selectedPatient.visitDate}
  </Typography>
  
  <Button
    variant="outlined"
    color="warning"
    size="small"
    onClick={() => setPrecautionDialogOpen(true)}
    sx={{
      mt: 1,
      textTransform: 'none',
      fontWeight: 600,
      borderWidth: 2,
      '&:hover': {
        borderWidth: 2,
        transform: 'scale(1.02)',
        boxShadow: '0 4px 12px rgba(255, 152, 0, 0.3)'
      },
      transition: 'all 0.2s ease'
    }}
  >
    ⚠️ Special Precaution
  </Button>
</Box>
          </Stack>
        </Grid>

       {/* Vital Signs Preview */}
<Grid item xs={12} md={3} size={3}>
  <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
    <Typography variant="h6" fontWeight={700} color="primary">Vital Signs</Typography>
  </Box>
  <Stack spacing={0.8}>
    <Typography variant="body2"><strong>Temperature:</strong> {selectedPatient?.vitals?.temperature ?? "-"}°C</Typography>
    <Typography variant="body2"><strong>Blood Pressure:</strong> {selectedPatient?.vitals?.bp ?? "-"} mmHg</Typography>
    <Typography variant="body2"><strong>Pulse:</strong> {selectedPatient?.vitals?.pulse ?? "-"} bpm</Typography>
    <Typography variant="body2"><strong>Respiration Rate:</strong> {selectedPatient?.vitals?.respiration ?? "-"} breaths/min</Typography>
    <Typography variant="body2"><strong>SpO₂:</strong> {selectedPatient?.vitals?.spo2 ?? "-"}%</Typography>
  </Stack>
</Grid>

<Grid item xs={12} md={3}>
  <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
    <Typography variant="h6" fontWeight={700} color="primary"></Typography>
    <IconButton color="primary" size="small" onClick={() => setVitalsHistoryOpen(true)}
      title="View Vital Signs History"
      sx={{ bgcolor: 'primary.main', color: 'white', '&:hover': { bgcolor: 'primary.dark' } }}>
      <History />
    </IconButton>
  </Box>
  <Stack spacing={0.8}>
    <Typography variant="body2"><strong>Weight:</strong> {selectedPatient?.vitals?.weight ?? "-"} kg</Typography>
    <Typography variant="body2"><strong>Height:</strong> {selectedPatient?.vitals?.height ?? "-"} cm</Typography>
    <Typography variant="body2"><strong>BMI:</strong> {selectedPatient?.vitals?.bmi ?? "-"}</Typography>
    <Typography variant="body2">
      <strong>FBS:</strong>{" "}
      {selectedPatient?.vitals?.fbs ? (
        <Box component="span" sx={{ color: parseFloat(selectedPatient.vitals.fbs) > 7 ? '#DC2626' : 'inherit', fontWeight: parseFloat(selectedPatient.vitals.fbs) > 7 ? 700 : 400 }}>
          {selectedPatient.vitals.fbs} mmol/L
        </Box>
      ) : "—"}
    </Typography>
    <Typography variant="body2">
      <strong>RBS:</strong>{" "}
      {selectedPatient?.vitals?.rbs ? (
        <Box component="span" sx={{ color: parseFloat(selectedPatient.vitals.rbs) > 11.1 ? '#DC2626' : 'inherit', fontWeight: parseFloat(selectedPatient.vitals.rbs) > 11.1 ? 700 : 400 }}>
          {selectedPatient.vitals.rbs} mmol/L
        </Box>
      ) : "—"}
    </Typography>
  </Stack>
</Grid>


      </Grid>

      
    </Box>

    {/* Body Section - Full Vital Signs Details */}
   <CardContent sx={{ p: 1.25, "&:last-child": { pb: 1.25 } }}>
    <Box sx={{
      display: "grid",
      gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
      gap: 1,
    }}>
      {/* Admission Details — single line */}
      <Box sx={{
        p: 1, borderRadius: 1.5,
        border: "1px solid #cfe1ff",
        bgcolor: "rgba(33,150,243,0.06)",
        display: "flex", flexWrap: "wrap", alignItems: "center", columnGap: 1.25, rowGap: 0.25,
      }}>
        <Typography sx={{ fontSize: "0.7rem", fontWeight: 800, letterSpacing: "0.5px", textTransform: "uppercase", color: "#1e40af", mr: 0.5 }}>
          Admission
        </Typography>
        {[
          { label: "At",   value: admiAT },
          { label: "By",   value: admit_by },
          { label: "On",   value: admmission_note },
        ].map(i => (
          <Typography key={i.label} sx={{ fontSize: "0.78rem", color: "#0f172a" }}>
            <Box component="span" sx={{ color: "#64748b", fontWeight: 700 }}>{i.label}:</Box> {i.value || "—"}
          </Typography>
        ))}
      </Box>

      {/* Clinical Category — single line */}
      <Box sx={{
        p: 1, borderRadius: 1.5,
        border: "1px solid #ffd9b3",
        bgcolor: "rgba(255,152,0,0.06)",
        display: "flex", flexWrap: "wrap", alignItems: "center", columnGap: 1.25, rowGap: 0.25,
      }}>
        <Typography sx={{ fontSize: "0.7rem", fontWeight: 800, letterSpacing: "0.5px", textTransform: "uppercase", color: "#92400E", mr: 0.5 }}>
          Clinical
        </Typography>
        {[
          { label: "Attendance", value: attendanceType },
          { label: "Diagnosis",  value: Diagnosis },
          { label: "Procedure",  value: procedure_ },
        ].map(i => (
          <Typography key={i.label} sx={{ fontSize: "0.78rem", color: "#0f172a" }}>
            <Box component="span" sx={{ color: "#64748b", fontWeight: 700 }}>{i.label}:</Box> {i.value || "—"}
          </Typography>
        ))}
      </Box>
    </Box>
  </CardContent>
  </Card>
  </Collapse>
)}


 {/* --- Consultation Section --- */}
    
 {selectedPatient ? (
  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, minHeight: '70vh' }}>
    {/* Sidebar Tabs */}
    <Paper
      sx={{
        width: { xs: '100%', sm: 64, md: 64 },
        flexShrink: 0,
        borderRadius: { xs: 0, sm: 1 },
        mr: { sm: 2 },
        mb: { xs: 2, sm: 0 },
        maxHeight: { sm: '70vh' },
        overflow: 'auto',
        transition: 'width 0.3s ease',
        opacity: selectedPatient.state === 'Discharge' ? 0.5 : 1,  // ← ADD THIS
        pointerEvents: selectedPatient.state === 'Discharge' ? 'none' : 'auto',  // ← ADD THIS
        '&:hover': {
          width: { sm: 200, md: 240 },
          // Show all tab labels when hovering over the Paper container
          '& .MuiTab-root': {
            fontSize: { sm: '0.875rem' },
            justifyContent: { sm: 'flex-start' },
            paddingLeft: { sm: '16px' },
            '& .MuiTab-iconWrapper': {
              marginRight: { sm: '12px' }
            }
          }
        }
      }}
    >
      <Tabs
        value={activeTab}
        onChange={(e, v) => {
           if (selectedPatient.state === 'Discharge') return; 
         
          setActiveTab(v);
        }}
        orientation="vertical"
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          '& .MuiTab-root': {
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: { xs: '100%', sm: 64, md: 64 },
            minHeight: { xs: 52, sm: 64, md: 64 },
            fontSize: { xs: '0.75rem', sm: '0' },
            padding: { xs: '10px 12px', sm: '12px 8px' },
            borderBottom: '1px solid',
            borderBottomColor: 'divider',
            transition: 'all 0.3s ease',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            '& .MuiTab-iconWrapper': {
              marginBottom: { xs: 0, sm: 0 },
              marginRight: { xs: '8px', sm: 0 }
            },
            '&.Mui-selected': {
              backgroundColor: 'action.selected',
              fontWeight: 600,
            }
          },
        }}
      >

        <Tab
          label="Information/ Note"
          icon={<LocalHospital />}
          iconPosition="start"
        />
        <Tab
          label="Laboratory"
          icon={<Science />}
          iconPosition="start"
        />
        <Tab
          label="Scan"
          icon={<CameraAlt />}
          iconPosition="start"
        />
        <Tab
          label="Medication"
          icon={<Medication />}
          iconPosition="start"
        />
        <Tab
          label="Other Service"
          icon={<RoomService />}
          iconPosition="start"
        />
        <Tab
          label="Appointment"
          icon={<CalendarMonth />}
          iconPosition="start"
        />
        <Tab
          label="Discharge Patient"
          icon={<Hotel />}
          iconPosition="start"
        />


         <Tab
          label="Death"
          icon={<AirlineSeatFlatAngledIcon />}
          iconPosition="start"
        />

        <Tab
          label="Referee"
          icon={<PersonAdd />}
          iconPosition="start"
        />

       
          {/* ✅ Only show this tab when patient status is Detention */}
          {selectedPatient?.status === 'Detention' && (
            <Tab
              label="Admit Detention Patient"
              icon={<Hotel />}
              iconPosition="start"
            />
          )}

          

      </Tabs>
    </Paper>

    {/* Main Content Area */}
      <Paper sx={{ 
      flexGrow: 1, 
      p: { xs: 2, sm: 3 },
      opacity: selectedPatient.state === 'Discharge' ? 0.5 : 1,  // ← ADD THIS
      pointerEvents: selectedPatient.state === 'Discharge' ? 'none' : 'auto'  // ← ADD THIS
    }}>
      {/* --- Quick Access Buttons --- */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1.5,
          mb: 2,
          justifyContent: "flex-start",
        }}
      >
        <Tooltip title="View full medical record history">
          <Button
          variant="outlined"
          color="primary"
          onClick={() => setMedHistoryOpen(true)}
          startIcon={<Notes />}
        >
          Medical History
        </Button>
        </Tooltip>

         <Tooltip title="Review past Vitals results">
          <Button
            variant="outlined"
            color="success"
           
            startIcon={<History />}
             onClick={() => setVitalsHistoryOpen(true)}
          >
            Vitals History
          </Button>
        </Tooltip>

        <Tooltip title="Review past laboratory results">
          <Button
            variant="outlined"
            color="secondary"
           
            startIcon={<Science />}
             onClick={() => setlabHistoryOpen(true)}
          >
            Lab History
          </Button>
        </Tooltip>

        <Tooltip title="View previous scan/imaging results">
          <Button
            variant="outlined"
            color="info"
             onClick={() => setScanHistoryOpen(true)}
            startIcon={<CameraAlt />}
          >
            Scan History
          </Button>
        </Tooltip>

        <Tooltip title="Check previous medications prescribed">
          <Button
            variant="outlined"
            color="success"
            onClick={() => setopenmedHis(true)}
            startIcon={<Medication />}
          >
            Medication History
          </Button>
        </Tooltip>

      </Box>

      <Divider sx={{ my: 3}} />
   
{activeTab === 0 && (
  <Box>
    <Box sx={{ p: 3, bgcolor: '#f5f5f5', minHeight: '50vh' }}>
    <Paper sx={{ p: 4, maxWidth: 1400, mx: 'auto' }}>

      <Box
        sx={{
          display: 'grid',
          gap: 3,
          alignItems: 'start',
          gridTemplateColumns: {
            xs: '1fr',
            md: '1fr 1fr',
            lg: '1fr 1fr 1fr',
            xl: '1fr 1fr 1fr 1fr'
          }
        }}
      >
        {/* Complaint */}
        <Box
          sx={{
            border: '2px solid #e0e0e0',
            borderRadius: 2,
            p: 2.5,
            bgcolor: '#fafafa',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              mb: 2.5,
              color: '#1976d2',
              borderBottom: '2px solid #1976d2',
              pb: 1,
              flexShrink: 0
            }}
          >
            Complaint
          </Typography>

          <Box sx={{ maxHeight: 300, overflowY: 'auto', pr: 1 }}>
            {wardRoundsData.map((entry, index) => (
              <Box
                key={index}
                sx={{
                  mb: 3,
                  pb: 2.5,
                  borderBottom:
                    index < wardRoundsData.length - 1 ? '1px solid #e0e0e0' : 'none'
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: '1rem',
                    fontWeight: 700,
                    color: '#1976d2',
                    textDecoration: 'underline',
                    mb: 1.5
                  }}
                >
                  {entry.date}
                </Typography>

                <Typography
                  sx={{
                    whiteSpace: 'pre-wrap',
                    lineHeight: 1.7,
                    fontSize: '0.9rem',
                    color: '#333'
                  }}
                >
                  {entry.complaint}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Physical Examination */}
        <Box
          sx={{
            border: '2px solid #e0e0e0',
            borderRadius: 2,
            p: 2.5,
            bgcolor: '#fafafa',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              mb: 2.5,
              color: '#2e7d32',
              borderBottom: '2px solid #2e7d32',
              pb: 1,
              flexShrink: 0
            }}
          >
            Physical Examination
          </Typography>

          <Box sx={{ maxHeight: 300, overflowY: 'auto', pr: 1 }}>
            {wardRoundsData.map((entry, index) => (
              <Box
                key={index}
                sx={{
                  mb: 3,
                  pb: 2.5,
                  borderBottom:
                    index < wardRoundsData.length - 1 ? '1px solid #e0e0e0' : 'none'
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: '1rem',
                    fontWeight: 700,
                    color: '#2e7d32',
                    textDecoration: 'underline',
                    mb: 1.5
                  }}
                >
                  {entry.date}
                </Typography>

                <Typography
                  sx={{
                    whiteSpace: 'pre-wrap',
                    lineHeight: 1.7,
                    fontSize: '0.9rem',
                    color: '#333'
                  }}
                >
                  {entry.physicalExam}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Other Documentation */}
        <Box
          sx={{
            border: '2px solid #e0e0e0',
            borderRadius: 2,
            p: 2.5,
            bgcolor: '#fafafa',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              mb: 2.5,
              color: '#ed6c02',
              borderBottom: '2px solid #ed6c02',
              pb: 1,
              flexShrink: 0
            }}
          >
            Other Documentation
          </Typography>

          <Box sx={{ maxHeight: 300, overflowY: 'auto', pr: 1 }}>
            {wardRoundsData.map((entry, index) => (
              <Box
                key={index}
                sx={{
                  mb: 3,
                  pb: 2.5,
                  borderBottom:
                    index < wardRoundsData.length - 1 ? '1px solid #e0e0e0' : 'none'
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: '1rem',
                    fontWeight: 700,
                    color: '#ed6c02',
                    textDecoration: 'underline',
                    mb: 1.5
                  }}
                >
                  {entry.date}
                </Typography>

                <Typography
                  sx={{
                    whiteSpace: 'pre-wrap',
                    lineHeight: 1.7,
                    fontSize: '0.9rem',
                    color: '#333'
                  }}
                >
                  {entry.otherDocumentation}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Surgical Notes */}
        <Box
          sx={{
            border: '2px solid #e0e0e0',
            borderRadius: 2,
            p: 2.5,
            bgcolor: '#fafafa',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              mb: 2.5,
              color: '#d32f2f',
              borderBottom: '2px solid #d32f2f',
              pb: 1,
              flexShrink: 0
            }}
          >
            Surgical Notes
          </Typography>

          <Box sx={{ maxHeight: 300, overflowY: 'auto', pr: 1 }}>
            {wardRoundsData.map((entry, index) => (
              <Box
                key={index}
                sx={{
                  mb: 3,
                  pb: 2.5,
                  borderBottom:
                    index < wardRoundsData.length - 1 ? '1px solid #e0e0e0' : 'none'
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: '1rem',
                    fontWeight: 700,
                    color: '#d32f2f',
                    textDecoration: 'underline',
                    mb: 1.5
                  }}
                >
                  {entry.date}
                </Typography>

                <Typography
                  sx={{
                    whiteSpace: 'pre-wrap',
                    lineHeight: 1.7,
                    fontSize: '0.9rem',
                    color: '#333'
                  }}
                >
                  {entry.surgicalNotes}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Doctors Plan  */}
      <Box
      sx={{
        border: '2px solid #e0e0e0',
        borderRadius: 2,
        p: 2.5,
        bgcolor: '#fafafa',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          mb: 2.5,
          color: '#336327ff',
          borderBottom: '2px solid #9fd81cff',
          pb: 1,
          flexShrink: 0
        }}
      >
        Doctors Plan
      </Typography>

      <Box sx={{ maxHeight: 300, overflowY: 'auto', pr: 1 }}>
        {wardRoundsData.map((entry, index) => (
          <Box
            key={index}
            sx={{
              mb: 3,
              pb: 2.5,
              borderBottom:
                index < wardRoundsData.length - 1 ? '1px solid #e0e0e0' : 'none'
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: '1rem',
                fontWeight: 700,
                color: '#475a19ff',
                textDecoration: 'underline',
                mb: 1.5
              }}
            >
              {entry.date}
            </Typography>

            <Typography
              sx={{
                whiteSpace: 'pre-wrap',
                lineHeight: 1.7,
                fontSize: '0.9rem',
                color: '#333'
              }}
            >
              {entry.plan}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>

      {/* ================= DIAGNOSIS & PROCEDURES BOX ================= */}
      <Box
        sx={{
          border: '2px solid #e0e0e0',
          borderRadius: 2,
          p: 2.5,
          bgcolor: '#fafafa',
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            mb: 2.5,
            color: '#6a1b9a',
            borderBottom: '2px solid #6a1b9a',
            pb: 1,
            flexShrink: 0
          }}
        >
          Diagnosis & Procedure(s)
        </Typography>

        <Box sx={{ maxHeight: 300, overflowY: 'auto', pr: 1 }}>

          {/* ===== DIAGNOSIS LIST ===== */}
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, mb: 1 }}
          >
            Diagnosis(es)
          </Typography>

          {selectedDiagnoses?.length > 0 ? (
            <Box sx={{ ml: 1 }}>
              {selectedDiagnoses.map((diag, idx) => (
                <Typography
                  key={idx}
                  sx={{
                    mb: 1,
                    fontSize: '0.9rem',
                    lineHeight: 1.6,
                    color: '#333'
                  }}
                >
                  • <strong>{diag.code}</strong> — {diag.name}
                </Typography>
              ))}
            </Box>
          ) : (
            <Typography sx={{ fontSize: '0.85rem', color: '#999', ml: 1 }}>
              No diagnosis recorded.
            </Typography>
          )}

          <Divider sx={{ my: 2 }} />

          {/* ===== PROCEDURES LIST ===== */}
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, mb: 1 }}
          >
            Procedure(s)
          </Typography>

          {selectedProcedures?.length > 0 ? (
            <Box sx={{ ml: 1 }}>
              {selectedProcedures.map((proc, idx) => (
                <Typography
                  key={idx}
                  sx={{
                    mb: 1,
                    fontSize: '0.9rem',
                    lineHeight: 1.6,
                    color: '#333'
                  }}
                >
                  • {proc.name}
                </Typography>
              ))}
            </Box>
          ) : (
            <Typography sx={{ fontSize: '0.85rem', color: '#999', ml: 1 }}>
              No procedure recorded.
            </Typography>
          )}

        </Box>
      </Box>


      </Box>

    </Paper>
  </Box>

  

  </Box>
  

  
)}


{/* --- Laboratory --- */}
{activeTab === 1 && (
  <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
    {/* --- Available Labs (Left Side) --- */}
    <Grid item xs={12} md={6} size={5}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Available Labs
        </Typography>
        <TextField
          fullWidth
          placeholder="Search lab by name..."
          value={labSearchTerm}
          onChange={(e) => setLabSearchTerm(e.target.value)}
          sx={{ mb: 2 }}
          size="small"
        />

        {/* Responsive Table */}
        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Lab</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Amount</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }} align="center">
                  Request
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {labs
                .filter((lab) =>
                  lab.name.toLowerCase().includes(labSearchTerm.toLowerCase())
                )
                .slice(labPage * labRowsPerPage, labPage * labRowsPerPage + labRowsPerPage)
                .map((lab, idx) => (
                  <TableRow
                    key={idx}
                    sx={{ "&:nth-of-type(odd)": { backgroundColor: "action.hover" } }}
                  >
                    <TableCell sx={{ fontSize: "0.75rem" }}>{lab.name}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}> {formatWithOutSom (lab.amount)}</TableCell>
                    <TableCell align="center">
                      <IconButton color="primary" onClick={() => handleRequestLab(lab)} size="small">
                        <Send fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={labs.filter((lab) =>
            lab.name.toLowerCase().includes(labSearchTerm.toLowerCase())
          ).length}
          page={labPage}
          onPageChange={(e, newPage) => setLabPage(newPage)}
          rowsPerPage={labRowsPerPage}
          onRowsPerPageChange={(e) => {
            setLabRowsPerPage(parseInt(e.target.value, 10));
            setLabPage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>
    </Grid>

    {/* --- Requested Labs (Right Side) --- */}
    <Grid item xs={12} md={6} size={7}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Requested Labs
        </Typography>

        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Date</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Lab</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Amount</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Requested By</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Status</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Paid By</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requestedLabs
                .slice(reqPage * reqRowsPerPage, reqPage * reqRowsPerPage + reqRowsPerPage)
                .map((req, idx) => (
                  <TableRow
                    key={idx}
                    sx={{ "&:nth-of-type(odd)": { backgroundColor: "action.hover" } }}
                  >
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.date}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.lab}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{ formatWithOutSom(req.amount)}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.requestedBy}</TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        label={req.status}
                        color={req.status === "paid" ? "success" : "warning"}
                        sx={{ fontSize: "0.7rem" }}
                      />
                    </TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.labBy || "-"}</TableCell>
                    <TableCell>
                     {req.date?.substring(0, 10) === currentDate ? (
                      // ✅ Allow delete today
                      <IconButton
                        color="error"
                        size="small"
                        onClick={() => handleDeleteRequest(req)}
                      >
                        <Close fontSize="small" />
                      </IconButton>
                    ) : (
                      // 🔒 Disable delete for previous days
                      <IconButton color="disabled" size="small" disabled>
                        <LockIcon fontSize="small" />
                      </IconButton>
                    )}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={requestedLabs.length}
          page={reqPage}
          onPageChange={(e, newPage) => setReqPage(newPage)}
          rowsPerPage={reqRowsPerPage}
          onRowsPerPageChange={(e) => {
            setReqRowsPerPage(parseInt(e.target.value, 10));
            setReqPage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />

        {/* Totals Section */}
        <Box
          sx={{
            mt: 2,
            p: 1.5,
            borderRadius: 2,
            background: "linear-gradient(90deg, #e3f2fd, #e8f5e9)",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" fontWeight="bold" color="warning.main">
            Total Pending: GH₵{" "}
            {formatWithOutSom (requestedLabs
              .filter((r) => r.status === "pending")
              .reduce((sum, r) => sum + r.amount, 0))}
          </Typography>
          <Typography variant="caption" fontWeight="bold" color="success.main">
            Total Paid: GH₵{" "}
            {formatWithOutSom (requestedLabs
              .filter((r) => r.status === "paid")
              .reduce((sum, r) => sum + r.amount, 0))}
          </Typography>
        </Box>
      </Paper>
    </Grid>
  </Grid>
)}


{/* --- Scan --- */}
{activeTab === 2 && (
  <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
    {/* --- Available Scans (Left Side) --- */}
    <Grid item xs={12} md={6} size={5}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Available Scans
        </Typography>
        <TextField
          fullWidth
          placeholder="Search scan by name..."
          value={scanSearchTerm}
          onChange={(e) => setScanSearchTerm(e.target.value)}
          sx={{ mb: 2 }}
          size="small"
        />

        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Scan</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Amount</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }} align="center">
                  Request
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {scans
                .filter((scan) =>
                  scan.name.toLowerCase().includes(scanSearchTerm.toLowerCase())
                )
                .slice(scanPage * scanRowsPerPage, scanPage * scanRowsPerPage + scanRowsPerPage)
                .map((scan, idx) => (
                  <TableRow
                    key={idx}
                    sx={{ "&:nth-of-type(odd)": { backgroundColor: "action.hover" } }}
                  >
                    <TableCell sx={{ fontSize: "0.75rem" }}>{scan.name}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{ formatWithOutSom(scan.amount)}</TableCell>
                    <TableCell align="center">
                      <IconButton color="primary" onClick={() => handleRequestScan(scan)} size="small">
                        <Send fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={scans.filter((scan) =>
            scan.name.toLowerCase().includes(scanSearchTerm.toLowerCase())
          ).length}
          page={scanPage}
          onPageChange={(e, newPage) => setScanPage(newPage)}
          rowsPerPage={scanRowsPerPage}
          onRowsPerPageChange={(e) => {
            setScanRowsPerPage(parseInt(e.target.value, 10));
            setScanPage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>
    </Grid>

    {/* --- Requested Scans (Right Side) --- */}
    <Grid item xs={12} md={6} size={7}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Requested Scans
        </Typography>

        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Date</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Scan</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Amount</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Requested By</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Status</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Scan By</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requestedScans
                .slice(reqScanPage * reqScanRowsPerPage, reqScanPage * reqScanRowsPerPage + reqScanRowsPerPage)
                .map((req, idx) => (
                  <TableRow
                    key={idx}
                    sx={{ "&:nth-of-type(odd)": { backgroundColor: "action.hover" } }}
                  >
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.date}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.lab}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{ formatWithOutSom(req.amount)}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.requestedBy}</TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        label={req.status}
                        color={req.status === "paid" ? "success" : "warning"}
                        sx={{ fontSize: "0.7rem" }}
                      />
                    </TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.scanBy || "-"}</TableCell>
                    <TableCell>
                     <TableCell>
                      {req.date?.substring(0, 10) === currentDate ? (
                        // ✅ TODAY — allow delete
                        <IconButton
                          color="error"
                          size="small"
                          onClick={() => handleDeleteScanRequest(req)}
                        >
                          <Close fontSize="small" />
                        </IconButton>
                      ) : (
                        // 🔒 NOT TODAY — show disabled lock with tooltip
                        <Tooltip title="Cannot delete previous scan requests">
                          <span>
                            <IconButton color="disabled" size="small" disabled>
                              <LockIcon fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                      )}
                    </TableCell>

                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={requestedScans.length}
          page={reqScanPage}
          onPageChange={(e, newPage) => setReqScanPage(newPage)}
          rowsPerPage={reqScanRowsPerPage}
          onRowsPerPageChange={(e) => {
            setReqScanRowsPerPage(parseInt(e.target.value, 10));
            setReqScanPage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />

        {/* Totals */}
        <Box
          sx={{
            mt: 2,
            p: 1.5,
            borderRadius: 2,
            background: "linear-gradient(90deg, #fff3e0, #e8f5e9)",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" fontWeight="bold" color="warning.main">
            Total Pending: GH₵{" "}
            {formatWithOutSom (requestedScans
              .filter((r) => r.status === "pending")
              .reduce((sum, r) => sum + r.amount, 0))}
          </Typography>
          <Typography variant="caption" fontWeight="bold" color="success.main">
            Total Paid: GH₵{" "}
            {formatWithOutSom (requestedScans
              .filter((r) => r.status === "paid")
              .reduce((sum, r) => sum + r.amount, 0))}
          </Typography>
        </Box>
      </Paper>
    </Grid>
  </Grid>
)}


{/* --- Medication --- */}
{activeTab === 3 && (
  <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
    
    {/* --- Full View Button --- */}
   
     <Button
      fullWidth
      variant="outlined"
      color="primary"
      size="large"
      onClick={() => setMedDialogOpen(true)}
      sx={{
        py: 2,            // taller button
        fontSize: "1rem", // bigger text
        fontWeight: 600
      }}
    >
      Open Full Medication View
    </Button>
   

    {/* --- Available Medications (Column 1) --- */}
    <Grid item xs={12} md={4} size={3}>
      <Paper sx={{ p: 1.5, borderRadius: 2, boxShadow: 2 }}>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          Available Medications
        </Typography>

        <TextField
          fullWidth
          placeholder="Search medication..."
          value={medSearchTerm}
          onChange={(e) => setMedSearchTerm(e.target.value)}
          size="big"
          margin="dense"
        />

        <TableContainer sx={{ maxHeight: 450 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Medication</TableCell>
                <TableCell align="center" sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>
                  Select
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {medications
                .filter((med) => med.name.toLowerCase().includes(medSearchTerm.toLowerCase()))
                .slice(medPage * medRowsPerPage, medPage * medRowsPerPage + medRowsPerPage)
                .map((med, idx) => (
                  <TableRow
                    key={idx}
                    sx={{ "&:nth-of-type(odd)": { backgroundColor: "action.hover" } }}
                  >
                  <TableCell sx={{ fontSize: "0.8rem" }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {med.name}
                      <Tooltip title="Medication Info">
                        <IconButton
                          size="small"
                          color="info"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleMedicationInfo(med);
                          }}
                          sx={{ ml: 'auto' }}
                        >
                          <Info fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>
                    <TableCell align="center">
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() => {
                          setSelectedMed(med);
                          const { medStrength } = extractStrengthFromName(med.name);
                          setDoseUnit(medStrength || "");
                          setAutoCalculate(isSolidByName(med.name) || isAutoCalcUnit(medStrength));
                        }}
                      >
                        <Send fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={medications.filter((med) =>
            med.name.toLowerCase().includes(medSearchTerm.toLowerCase())
          ).length}
          page={medPage}
          onPageChange={(e, newPage) => setMedPage(newPage)}
          rowsPerPage={medRowsPerPage}
          onRowsPerPageChange={(e) => {
            setMedRowsPerPage(parseInt(e.target.value, 10));
            setMedPage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>
    </Grid>

    {/* --- Medication Request Form (Column 2) --- */}
    <Grid item xs={12} md={4} size={3}>
      <Paper sx={{ p: 1.5, borderRadius: 2, boxShadow: 2 }}>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          Medication Request
        </Typography>

       <TextField
          label="Selected Medication"
          value={selectedMed?.name || ""}
          fullWidth
          margin="dense"
          disabled
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000",   // text color
              opacity: 1,                    // remove dim
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#000",                 // label color
              opacity: 1,
            }
          }}
        />

        <TextField
          label="Medication Status"
          value={selectedMed?.status || ""}
          fullWidth
          margin="dense"
          disabled
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000",
              opacity: 1,
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#000",
              opacity: 1,
            }
          }}
        />


        <FormControlLabel
          control={
            <Checkbox
              checked={autoCalculate}
              onChange={(e) => setAutoCalculate(e.target.checked)}
              size="big"
            />
          }
          label={<Typography fontSize="0.8rem">Auto Calculate Quantity</Typography>}
          sx={{ mb: 1 }}
        />

        
          
            <TextField
              label="Dose Amount"
              type="number"
              value={doseAmount}
              onChange={(e) => {
                setDoseAmount(e.target.value);
                if (e.target.value) setDoseAmountError(false);
              }}
              fullWidth
              size="big"
              margin="dense"
              error={doseAmountError}
              helperText={doseAmountError ? "Required" : ""}
            />
          
          
            <TextField
              label="Dose Unit"
              placeholder="ml, mg, tab"
              value={doseUnit}
              onChange={(e) => setDoseUnit(e.target.value)}
              fullWidth
              size="big"
              margin="dense"
            />
          
      
        <FormControl fullWidth margin="dense" size="big" error={frequencyError}>
          <InputLabel>Frequency</InputLabel>
          <Select
            value={frequency}
            onChange={(e) => {
              setFrequency(e.target.value);
              if (e.target.value) setFrequencyError(false);
            }}
          >
            {standardFrequencies.map((freq) => (
              <MenuItem key={freq} value={freq} sx={{ fontSize: "0.85rem" }}>
                {freq}
              </MenuItem>
            ))}
          </Select>
          {frequencyError && <FormHelperText>Required</FormHelperText>}
        </FormControl>

        <TextField
          label="Days"
          type="number"
          value={days}
          onChange={(e) => {
            const val = Number(e.target.value);
            setDays(val);
            if (val > 0) setDaysError(false);
          }}
          fullWidth
          size="big"
          margin="dense"
          error={daysError}
          helperText={daysError ? "Must be > 0" : ""}
        />

        <FormControl fullWidth margin="dense" size="big" error={routeError}>
          <InputLabel>Route</InputLabel>
          <Select
            value={route}
            onChange={(e) => {
              setRoute(e.target.value);
              if (e.target.value) setRouteError(false);
            }}
          >
            {MEDICATION_ROUTES.map((rt) => (
              <MenuItem key={rt} value={rt} sx={{ fontSize: "0.85rem" }}>
                {rt}
              </MenuItem>
            ))}
          </Select>
          {routeError && <FormHelperText>Required</FormHelperText>}
        </FormControl>

         <TextField
          label="Quantity"
          type="number"
          value={qty}
          onChange={(e) => !autoCalculate && setQty(Number(e.target.value))}
          fullWidth
          size="big"
          margin="dense"
          disabled={autoCalculate}
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000",   // makes text black
              opacity: 1,                     // full visibility
            },

            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#000",                // label color readable
              opacity: 1,
            },

            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ccc",
            }
          }}
        />

        <Stack spacing={1} direction="row" sx={{ mt: 1 }}>
          <Button 
            fullWidth 
            variant="contained" 
            size="small" 
            onClick={handleAddMedication}
          >
            Make Request
          </Button>
          <Button 
            fullWidth 
            variant="outlined" 
            color="error" 
            size="small"
            onClick={handleClearMedication}
          >
            Clear
          </Button>
        </Stack>
      </Paper>
    </Grid>

    {/* --- Requested Medications (Column 3) --- */}
    <Grid item xs={12} md={4} size={6}>
      <Paper sx={{ p: 1.5, borderRadius: 2, boxShadow: 2 }}>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          Requested Medications
        </Typography>

        <TableContainer sx={{ maxHeight: 350 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {["Drug", "Dose", "Freq", "Days", "Qty", "Route", "Cost"].map((col) => (
                  <TableCell
                    key={col}
                    sx={{ fontSize: "0.8rem", fontWeight: "bold", py: 0.5 }}
                  >
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {requestedMeds
                .slice(reqMedPage * reqMedRowsPerPage, reqMedPage * reqMedRowsPerPage + reqMedRowsPerPage)
                .map((req, idx) => (
                  <TableRow key={idx} sx={{ "&:nth-of-type(odd)": { backgroundColor: "action.hover" } }}>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>{req.drug}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>{req.dose}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>{req.freq}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>{req.days}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>{req.qty}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>{req.route}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>GH₵ {req.cost}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={requestedMeds.length}
          page={reqMedPage}
          onPageChange={(e, newPage) => setReqMedPage(newPage)}
          rowsPerPage={reqMedRowsPerPage}
          onRowsPerPageChange={(e) => {
            setReqMedRowsPerPage(parseInt(e.target.value, 10));
            setReqMedPage(0);
          }}
          rowsPerPageOptions={[10, 20, 35]}
        />

        {/* Totals */}
        <Box
          sx={{
            mt: 1,
            p: 1.5,
            borderRadius: 2,
            background: "linear-gradient(90deg, #f3e5f5, #e8f5e9)",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" fontWeight="bold" color="warning.main">
            Pending: GH₵{" "}
            {formatWithOutSom(requestedMeds.filter((r) => r.status === "pending").reduce((sum, r) => sum + r.cost, 0))}
          </Typography>
          <Typography variant="caption" fontWeight="bold" color="success.main">
            Paid: GH₵{" "}
            {formatWithOutSom (requestedMeds.filter((r) => r.status === "paid").reduce((sum, r) => sum + r.cost, 0))}
          </Typography>
        </Box>
      </Paper>
    </Grid>
  </Grid>
)}


{/* Other Serivces --*/}
{activeTab === 4 && (
  <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
    {/* --- Available Services (Left) --- */}
    <Grid item xs={12} md={6} size={6}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Available Non Insured Services
        </Typography>

        <TextField
          fullWidth
          placeholder="Search  Non Insured Services by name..."
          value={serviceSearchTerm}
          onChange={(e) => setServiceSearchTerm(e.target.value)}
          sx={{ mb: 2 }}
          size="big"
        />
        

        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table stickyHeader size="small">
           <TableHead>
            <TableRow>
              <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Service</TableCell>
              <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Quantity</TableCell>
              <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Amount</TableCell>
              <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }} align="center">
                Request
              </TableCell>
            </TableRow>
          </TableHead>

           <TableBody>
          {services
            .filter((srv) =>
              srv.name.toLowerCase().includes(serviceSearchTerm.toLowerCase())
            )
            .slice(servicePage * serviceRowsPerPage, servicePage * serviceRowsPerPage + serviceRowsPerPage)
            .map((srv, idx) => {
              const key = `${srv.name}-${idx}`;
              const quantity = serviceQuantities[key] || 1;
              const finalAmount = srv.amount * quantity;

              return (
                <TableRow key={key}>
                  {/* Service Name */}
                  <TableCell>{srv.name}</TableCell>

                  {/* Quantity Input */}
                  <TableCell>
                    <TextField
                      type="number"
                      size="small"
                      value={quantity}
                      inputProps={{ min: 1 }}
                      onChange={(e) => {
                        const val = Math.max(1, Number(e.target.value));
                        setServiceQuantities((prev) => ({ ...prev, [key]: val }));
                      }}
                      sx={{ width: 80 }}
                    />
                  </TableCell>

                  {/* Auto-updated Amount */}
                  <TableCell>{formatWithOutSom(finalAmount)}</TableCell>

                  {/* Request Button */}
                  <TableCell align="center">
                    <IconButton
                      color="primary"
                      onClick={() =>
                        handleRequestService({
                          ...srv,
                          amount: finalAmount,     // 👈 send multiplied amount
                          quantity,
                          
                        })
                      }
                    >
                      <Send />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>

          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={services.filter((srv) =>
            srv.name.toLowerCase().includes(serviceSearchTerm.toLowerCase())
          ).length}
          page={servicePage}
          onPageChange={(e, newPage) => setServicePage(newPage)}
          rowsPerPage={serviceRowsPerPage}
          onRowsPerPageChange={(e) => {
            setServiceRowsPerPage(parseInt(e.target.value, 10));
            setServicePage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>

      <Paper
            elevation={2}
            sx={{
              mt: 2,
              p: 2,
              borderRadius: 3,
              background: "linear-gradient(135deg,#fdfbfb 0%,#ebedee 100%)"
            }}
          >
            <Typography fontWeight={600} mb={2}>
              Request Service Not Listed
            </Typography>
      
            <Grid container spacing={2} alignItems="center" columns={{ xs: 4, sm: 8, md: 12 }}>
              <Grid item xs={12} md={5} size={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Service Name"
                  value={manualServiceName}
                  onChange={(e) => setManualServiceName(e.target.value)}
                />
              </Grid>
      
      
              <Grid item xs={12} md={3} size={3}>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  label="Amount"
                  value={manualAmount}
                  onChange={(e) => setManualAmount(e.target.value)}
                />
              </Grid>
      
              <Grid item xs={12} md={2} size={3}>
                <Button
                  fullWidth
                  variant="contained"
                  startIcon={<Send />}
                  onClick={handleManualServiceRequest}
                  sx={{
                    height: 40,
                    background:
                      "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
                    borderRadius: 2
                  }}
                >
                  Request
                </Button>
              </Grid>
            </Grid>
          </Paper>
    </Grid>

    {/* --- Requested Services (Right) --- */}
    <Grid item xs={12} md={6} size={6}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Requested Services
        </Typography>

        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Date</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Service</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Amount</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Requested By</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Status</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Paid By</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requestedServices
                .slice(
                  reqServicePage * reqServiceRowsPerPage,
                  reqServicePage * reqServiceRowsPerPage + reqServiceRowsPerPage
                )
                .map((req, idx) => (
                  <TableRow
                    key={idx}
                    sx={{ "&:nth-of-type(odd)": { backgroundColor: "action.hover" } }}
                  >
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.date}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.service}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{ formatWithOutSom(req.amount)}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.requestedBy}</TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        label={req.status}
                        color={req.status === "paid" ? "success" : "warning"}
                        sx={{ fontSize: "0.7rem" }}
                      />
                    </TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.servicedBy || "-"}</TableCell>
                    <TableCell>
                      {req.date?.substring(0, 10) === currentDate ? (
                        // ✅ Today — allow deletion
                        <IconButton
                          color="error"
                          size="small"
                          onClick={() => handleDeleteServiceRequest(req)}
                        >
                          <Close fontSize="small" />
                        </IconButton>
                      ) : (
                        // 🔒 Not Today — disable and show tooltip
                        <Tooltip title="Cannot delete past service requests">
                          <span>
                            <IconButton color="disabled" size="small" disabled>
                              <LockIcon fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                      )}
                    </TableCell>

                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={requestedServices.length}
          page={reqServicePage}
          onPageChange={(e, newPage) => setReqServicePage(newPage)}
          rowsPerPage={reqServiceRowsPerPage}
          onRowsPerPageChange={(e) => {
            setReqServiceRowsPerPage(parseInt(e.target.value, 10));
            setReqServicePage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />

        {/* Totals */}
        <Box
          sx={{
            mt: 2,
            p: 1.5,
            borderRadius: 2,
            background: "linear-gradient(90deg, #e1f5fe, #f1f8e9)",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" fontWeight="bold" color="warning.main">
            Total Pending: GH₵{" "}
            {formatWithOutSom(requestedServices
              .filter((r) => r.status === "pending")
              .reduce((sum, r) => sum + Number(r.amount), 0))}
          </Typography>

          <Typography variant="caption" fontWeight="bold" color="success.main">
            Total Paid: GH₵{" "}
            {formatWithOutSom(requestedServices
              .filter((r) => r.status === "paid")
              .reduce((sum, r) => sum + Number(r.amount), 0))}
          </Typography>

        </Box>

        
      </Paper>
    </Grid>
  </Grid>
)}

{/*-- Approintment --*/}

{activeTab === 5 && (
  <Box>
    <Grid container spacing={3}>

      {/* ---------- APPOINTMENT FORM ONLY ---------- */}
      <Grid item xs={12} >
        <Paper sx={{ p: 3 }}>
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, mb: 3 }}
            color="primary"
          >
            {editingAppointmentId ? "Update Appointment" : "Book New Appointment"}
          </Typography>

          <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
            <Grid item xs={12} sm={6} size={6}>
              <TextField
                fullWidth
                label="Appointment Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={appointmentDate}
                onChange={(e) => setAppointmentDate(e.target.value)}
                size="small"
              />
            </Grid>

            <Grid item xs={12} sm={6} size={6}>
              <TextField
                fullWidth
                label="Time"
                type="time"
                InputLabelProps={{ shrink: true }}
                value={appointmentTime}
                onChange={(e) => setAppointmentTime(e.target.value)}
                size="small"
              />
            </Grid>

            <Grid item xs={12} size={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Type of Appointment</InputLabel>
                <Select
                  value={appointmentType}
                  onChange={(e) => setAppointmentType(e.target.value)}
                  label="Type of Appointment"
                >
                  <MenuItem value="Consultation">Consultation</MenuItem>
                  <MenuItem value="Review">Review</MenuItem>
                  <MenuItem value="Procedure">Procedure</MenuItem>
                  <MenuItem value="Telemedicine">Telemedicine</MenuItem>
                  <MenuItem value="Follow-up">Follow-up</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} size={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={sendReminder}
                    onChange={(e) => setSendReminder(e.target.checked)}
                  />
                }
                label="Send Reminder"
              />
            </Grid>

            <Grid item xs={12} size={6}>
              <TextField
                fullWidth
                label="Reason for Appointment"
                multiline
                rows={3}
                value={appointmentReason}
                onChange={(e) => setAppointmentReason(e.target.value)}
                size="small"
              />
            </Grid>

            <Grid item xs={12} size={6}>
              <TextField
                fullWidth
                label="Other Information"
                multiline
                rows={3}
                value={appointmentOther}
                onChange={(e) => setAppointmentOther(e.target.value)}
                size="small"
              />
            </Grid>

            {/* SAVE or UPDATE BUTTON */}
            <Grid item xs={12} size={6}>
              <Button
                variant="contained"
                color={editingAppointmentId ? "warning" : "primary"}
                startIcon={<SaveIcon />}
                onClick={handleSaveAppointment}
              >
                {editingAppointmentId ? "Update Appointment" : "Save Appointment"}
              </Button>
            </Grid>

            {/* DELETE BUTTON — Only visible in edit mode */}
            {editingAppointmentId && (
              <Grid item xs={12} size={6}>
                <Button
                  variant="contained"
                  color="error"
                  startIcon={<Delete />}
                  onClick={() => handleDeleteAppointment(editingAppointmentId)}
                  sx={{ ml: 2 }}
                >
                  Delete Appointment
                </Button>
              </Grid>
            )}
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  </Box>
)}


{activeTab === 6 && (
  <Box>
    <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
      Discharge Patient
    </Typography>

    <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>

      {/* ---------- Row 2: Diagnoses and Procedures ---------- */}
      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Diagnoses
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {selectedDiagnoses && selectedDiagnoses.length > 0 ? (
            selectedDiagnoses.map((diag, idx) => (
              <Chip key={idx} label={diag.name} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No diagnosis selected
            </Typography>
          )}
        </Box>
      </Grid>

      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Procedures
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {selectedProcedures && selectedProcedures.length > 0 ? (
            selectedProcedures.map((proc, idx) => (
              <Chip key={idx} label={proc.name} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No procedure selected
            </Typography>
          )}
        </Box>
      </Grid>

      {/* ---------- Row 3: Laboratory & Scan Requested ---------- */}
      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Laboratory Requested
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {requestedLabs.length > 0 ? (
            requestedLabs.map((lab, idx) => (
              <Chip key={idx} label={lab.lab} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No lab requested
            </Typography>
          )}
        </Box>
      </Grid>

      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Scan Requested
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {requestedScans.length > 0 ? (
            requestedScans.map((scan, idx) => (
              <Chip key={idx} label={scan.lab} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No scan requested
            </Typography>
          )}
        </Box>
      </Grid>

      {/* ---------- Row 4: Medications & Other Services ---------- */}
      <Grid item xs={12} md={6} size={9}>
        <Typography variant="subtitle1" fontWeight={600}>
          Medications Requested
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {requestedMeds.length > 0 ? (
            requestedMeds.map((med, idx) => (
              <Chip key={idx} label={med.drug} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No medication requested
            </Typography>
          )}
        </Box>
      </Grid>

      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Other Services Requested
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {requestedServices.length > 0 ? (
            requestedServices.map((srv, idx) => (
              <Chip key={idx} label={srv.service} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No service requested
            </Typography>
          )}
        </Box>
      </Grid>

     
      {/* ---------- Row 5: Date & Time of Admission ---------- */}
      <Grid item xs={12} md={6} size={2}>
        <TextField
          fullWidth
          label="Date of Discharge"
          type="date"
          value={admissionDate}
          disabled
          onChange={(e) => setAdmissionDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item xs={12} md={6}size={2}>
        <TextField
          fullWidth
          label="Time of Admission"
          type="time"
          value={admissionTime}
          onChange={(e) => setAdmissionTime(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      {/* ---------- Row 6: Admission Note & Treatment Plan ---------- */}
      <Grid item xs={12} md={6} size={3}>
        <TextField
          fullWidth
          label="Discharge Note"
          multiline
          rows={5}
          value={admissionNote}
          onChange={(e) => setAdmissionNote(e.target.value)}
          placeholder="Enter detailed admission note..."
        />
      </Grid>
    </Grid>

    {/* Submit / Admit Button */}
    <Box sx={{ textAlign: "right", mt: 3 }}>
  <Button
    variant="contained"
    color="primary"
    startIcon={<Hotel />}
    onClick={() => {
      if (!validateAdmissionForm()) return;

      // 👉 Submit to backend
      submitAdmission();
      }}
  >
    Discharge Patient
  </Button>

    </Box>
  </Box>
)}


{activeTab === 7 && (
  <Box>
    <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
      Death
    </Typography>

    <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>

      {/* ---------- Row 2: Diagnoses and Procedures ---------- */}
      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Diagnoses
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {selectedDiagnoses && selectedDiagnoses.length > 0 ? (
            selectedDiagnoses.map((diag, idx) => (
              <Chip key={idx} label={diag.name} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No diagnosis selected
            </Typography>
          )}
        </Box>
      </Grid>

      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Procedures
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {selectedProcedures && selectedProcedures.length > 0 ? (
            selectedProcedures.map((proc, idx) => (
              <Chip key={idx} label={proc.name} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No procedure selected
            </Typography>
          )}
        </Box>
      </Grid>

      {/* ---------- Row 3: Laboratory & Scan Requested ---------- */}
      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Laboratory Requested
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {requestedLabs.length > 0 ? (
            requestedLabs.map((lab, idx) => (
              <Chip key={idx} label={lab.lab} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No lab requested
            </Typography>
          )}
        </Box>
      </Grid>

      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Scan Requested
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {requestedScans.length > 0 ? (
            requestedScans.map((scan, idx) => (
              <Chip key={idx} label={scan.lab} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No scan requested
            </Typography>
          )}
        </Box>
      </Grid>

      {/* ---------- Row 4: Medications & Other Services ---------- */}
      <Grid item xs={12} md={6} size={9}>
        <Typography variant="subtitle1" fontWeight={600}>
          Medications Requested
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {requestedMeds.length > 0 ? (
            requestedMeds.map((med, idx) => (
              <Chip key={idx} label={med.drug} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No medication requested
            </Typography>
          )}
        </Box>
      </Grid>

      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Other Services Requested
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {requestedServices.length > 0 ? (
            requestedServices.map((srv, idx) => (
              <Chip key={idx} label={srv.service} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No service requested
            </Typography>
          )}
        </Box>
      </Grid>

     
      {/* ---------- Row 5: Date & Time of Admission ---------- */}
      <Grid item xs={12} md={6} size={2}>
        <TextField
          fullWidth
          label="Date of Death"
          type="date"
          value={admissionDate}
          disabled
          onChange={(e) => setAdmissionDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item xs={12} md={6}size={2}>
        <TextField
          fullWidth
          label="Time of Death"
          type="time"
          value={admissionTime}
          onChange={(e) => setAdmissionTime(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      {/* ---------- Row 6: Admission Note & Treatment Plan ---------- */}
      <Grid item xs={12} md={6} size={3}>
        <TextField
          fullWidth
          label="Death Note / Cause Of Death"
          multiline
          rows={5}
          value={admissionNote}
          onChange={(e) => setAdmissionNote(e.target.value)}
          placeholder="Enter detailed admission note..."
        />
      </Grid>
    </Grid>

    {/* Submit / Admit Button */}
    <Box sx={{ textAlign: "right", mt: 3 }}>
  <Button
    variant="contained"
    color="primary"
    startIcon={<Hotel />}
    onClick={() => {
      if (!validateAdmissionForm()) return;

      // 👉 Submit to backend
      submitdeath();
      }}
  >
    Patient is Dead
  </Button>

    </Box>
  </Box>
)}

{activeTab === 8 && selectedPatient.status === 'Detention' && (
  <Box>
    <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
      Admit Detention Patient
    </Typography>

    <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>

      {/* ---------- Row 2: Diagnoses and Procedures ---------- */}
      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Diagnoses
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {selectedDiagnoses && selectedDiagnoses.length > 0 ? (
            selectedDiagnoses.map((diag, idx) => (
              <Chip key={idx} label={diag.name} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No diagnosis selected
            </Typography>
          )}
        </Box>
      </Grid>

      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Procedures
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {selectedProcedures && selectedProcedures.length > 0 ? (
            selectedProcedures.map((proc, idx) => (
              <Chip key={idx} label={proc.name} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No procedure selected
            </Typography>
          )}
        </Box>
      </Grid>

      {/* ---------- Row 3: Laboratory & Scan Requested ---------- */}
      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Laboratory Requested
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {requestedLabs.length > 0 ? (
            requestedLabs.map((lab, idx) => (
              <Chip key={idx} label={lab.lab} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No lab requested
            </Typography>
          )}
        </Box>
      </Grid>

      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Scan Requested
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {requestedScans.length > 0 ? (
            requestedScans.map((scan, idx) => (
              <Chip key={idx} label={scan.lab} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No scan requested
            </Typography>
          )}
        </Box>
      </Grid>

      {/* ---------- Row 4: Medications & Other Services ---------- */}
      <Grid item xs={12} md={6} size={9}>
        <Typography variant="subtitle1" fontWeight={600}>
          Medications Requested
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {requestedMeds.length > 0 ? (
            requestedMeds.map((med, idx) => (
              <Chip key={idx} label={med.drug} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No medication requested
            </Typography>
          )}
        </Box>
      </Grid>

      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Other Services Requested
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {requestedServices.length > 0 ? (
            requestedServices.map((srv, idx) => (
              <Chip key={idx} label={srv.service} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No service requested
            </Typography>
          )}
        </Box>
      </Grid>

      {/* ---------- Admission Status (WITHOUT Detention option) ---------- */}
      <Grid item xs={12} md={6} size={2}>
        <FormControl fullWidth error={admissionStatusError}>
          <InputLabel id="admission-status-label">Admission Status</InputLabel>
          <Select
            labelId="admission-status-label"
            label="Admission Status"
            value={admissionStatus}
            onChange={(e) => {
              setAdmissionStatus(e.target.value);
              setAdmissionStatusError(false);
            }}
          >
            <MenuItem value="Admission">Admission</MenuItem>
            <MenuItem value="Emergency">Emergency</MenuItem>
          </Select>
          {admissionStatusError && <FormHelperText>Required</FormHelperText>}
        </FormControl>
      </Grid>

      {/* ---------- Date & Time of Admission ---------- */}
      <Grid item xs={12} md={6} size={2}>
        <TextField
          fullWidth
          label="Date of Admission"
          type="date"
          value={admissionDate}
          disabled
          onChange={(e) => setAdmissionDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item xs={12} md={6} size={2}>
        <TextField
          fullWidth
          label="Time of Admission"
          type="time"
          value={admissionTime}
          onChange={(e) => setAdmissionTime(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      {/* ---------- Admission Note & Treatment Plan ---------- */}
      <Grid item xs={12} md={6} size={3}>
        <TextField
          fullWidth
          label="Reason for Admission"
          multiline
          rows={5}
          value={admissionNote}
          onChange={(e) => setAdmissionNote(e.target.value)}
          placeholder="Enter detailed admission reason / note..."
        />
      </Grid>

      <Grid item xs={12} md={6} size={3}>
        <TextField
          fullWidth
          label="Treatment Plan"
          multiline
          rows={5}
          value={treatmentPlan}
          onChange={(e) => setTreatmentPlan(e.target.value)}
          placeholder="Enter treatment plan..."
        />
      </Grid>
    </Grid>

    {/* Submit / Admit Button */}
    <Box sx={{ textAlign: "right", mt: 3 }}>
      <Button
        variant="contained"
        color="primary"
        startIcon={<Hotel />}
        onClick={() => {
          if (!validateAdmissionForm()) return;
          submitAdmission();
        }}
      >
        Admit Patient
      </Button>
    </Box>
  </Box>
)}



</Paper>
  </Box>
) : (
  <Paper
    sx={{
      p: 6,
      textAlign: "center",
      height: "60vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Box>
      <Person sx={{ fontSize: 80, color: "text.secondary", mb: 2 }} />
      <Typography variant="h6" color="text.secondary">
        Search and select a patient to begin consultation
      </Typography>
    </Box>
  </Paper>
)}


<Dialog open={medDialogOpen} onClose={() => setMedDialogOpen(false)} maxWidth="lx" fullWidth>
  <DialogTitle>Medication Full View</DialogTitle>
  <DialogContent>
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>

      {/* --- Available Medications (Column 1) --- */}
      <Grid item xs={12} md={4} size={3}>
        <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 2 }}>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Available Medications
          </Typography>

          <TextField
            fullWidth
            placeholder="Search medication..."
            value={medSearchTerm}
            onChange={(e) => setMedSearchTerm(e.target.value)}
            size="big"
            margin="dense"
            sx={{ mb: 1 }}
          />

          <TableContainer sx={{ maxHeight: 600 }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Medication</TableCell>
                  <TableCell align="center">Select</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {medications
                  .filter((med) =>
                    med.name.toLowerCase().includes(medSearchTerm.toLowerCase())
                  )
                  .slice(medPage * medRowsPerPage, medPage * medRowsPerPage + medRowsPerPage)
                  .map((med, idx) => (
                    <TableRow key={idx}>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          {med.name}
                          <Tooltip title="Medication Info">
                            <IconButton
                              size="small"
                              color="info"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleMedicationInfo(med);
                              }}
                              sx={{ ml: 'auto' }}
                            >
                              <Info fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                      <TableCell align="center">
                        <IconButton
                          color="primary"
                          size="small"
                          onClick={() => {
                            setSelectedMed(med);
                            const { medStrength } = extractStrengthFromName(med.name);
                            setDoseUnit(medStrength || "");
                            setAutoCalculate(isSolidByName(med.name) || isAutoCalcUnit(medStrength));
                          }}
                        >
                          <Send fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <TablePagination
            component="div"
            count={medications.filter((med) =>
              med.name.toLowerCase().includes(medSearchTerm.toLowerCase())
            ).length}
            page={medPage}
            onPageChange={(e, newPage) => setMedPage(newPage)}
            rowsPerPage={medRowsPerPage}
            onRowsPerPageChange={(e) => {
              setMedRowsPerPage(parseInt(e.target.value, 10));
              setMedPage(0);
            }}
            rowsPerPageOptions={[10, 20, 30]}
          />
        </Paper>
      </Grid>

      {/* --- Medication Request (Column 2) --- */}
      <Grid item xs={12} md={4} size={2} >
        <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 2 }}>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Medication Request
          </Typography>

          {/* Selected Medication */}
           <TextField
          label="Selected Medication"
          value={selectedMed?.name || ""}
          fullWidth
          margin="dense"
          disabled
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000",   // text color
              opacity: 1,                    // remove dim
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#000",                 // label color
              opacity: 1,
            }
          }}
        />

        <TextField
          label="Medication Status"
          value={selectedMed?.status || ""}
          fullWidth
          margin="dense"
          disabled
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000",
              opacity: 1,
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#000",
              opacity: 1,
            }
          }}
        />

          {/* Auto Calculate Toggle */}
          <FormControlLabel
            control={
              <Checkbox
                checked={autoCalculate}
                onChange={(e) => setAutoCalculate(e.target.checked)}
                size="big"
              />
            }
            label="Auto Calculate Quantity"
            sx={{ mb: 1 }}
          />

              <TextField
                label="Dose Amount"
                type="number"
                value={doseAmount}
                onChange={(e) => setDoseAmount(e.target.value)}
                fullWidth
                size="big"
                margin="dense"
              />
           
            
              <TextField
                label="Dose Unit"
                value={doseUnit}
                onChange={(e) => setDoseUnit(e.target.value)}
                fullWidth
                size="big"
                margin="dense"
              />

          {/* Frequency */}
          <FormControl fullWidth margin="dense" size="big">
            <InputLabel>Frequency</InputLabel>
            <Select
              value={frequency}
              onChange={(e) => setFrequency(e.target.value)}
            >
              {standardFrequencies.map((freq) => (
                <MenuItem key={freq} value={freq}>{freq}</MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Days */}
          <TextField
            label="Days"
            type="number"
            value={days}
            onChange={(e) => setDays(Number(e.target.value))}
            fullWidth
            size="big"
            margin="dense"
          />

          {/* Route */}
          <FormControl fullWidth margin="dense" size="big">
            <InputLabel>Route</InputLabel>
            <Select value={route} onChange={(e) => setRoute(e.target.value)}>
              {MEDICATION_ROUTES.map((rt) => (
                <MenuItem key={rt} value={rt}>{rt}</MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Quantity */}
         <TextField
          label="Quantity"
          type="number"
          value={qty}
          onChange={(e) => !autoCalculate && setQty(Number(e.target.value))}
          fullWidth
          size="big"
          margin="dense"
          disabled={autoCalculate}
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000",   // makes text black
              opacity: 1,                     // full visibility
            },

            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#000",                // label color readable
              opacity: 1,
            },

            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ccc",
            }
          }}
        />


          {/* Buttons (Update or Add) */}
          <Stack spacing={1} direction="row" sx={{ mt: 1 }}>
            {editingIndex !== null ? (
              <Button fullWidth variant="contained" size="small" color="success" onClick={handleUpdateMedication}>
                Update Request
              </Button>
            ) : (
              <Button fullWidth variant="contained" size="small" onClick={handleAddMedication}>
                Make Request
              </Button>
            )}
            <Button
              fullWidth
              variant="outlined"
              color="error"
              size="big"
              onClick={handleClearMedication}
            >
              Clear
            </Button>
          </Stack>
        </Paper>
      </Grid>

      {/* --- Requested Medications (Column 3) --- */}
      <Grid item xs={12} md={4} size={7}>
        <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 2 }}>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Requested Medications
          </Typography>

          <TableContainer sx={{ maxHeight: 600 }}>
            <Table size="big" stickyHeader>
              <TableHead>
                <TableRow>
                  {["Date", "Drug", "Dose", "Freq", "Days", "Qty", "Route", "Cost", "Requested By", "Served By", "Status", "Action"].map((col) => (
                    <TableCell key={col}>{col}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {requestedMeds
                  .slice(reqMedPage * reqMedRowsPerPage, reqMedPage * reqMedRowsPerPage + reqMedRowsPerPage)
                  .map((req, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{req.date}</TableCell>
                      <TableCell>{req.drug}</TableCell>
                      <TableCell>{req.dose}</TableCell>
                      <TableCell>{req.freq}</TableCell>
                      <TableCell>{req.days}</TableCell>
                      <TableCell>{req.qty}</TableCell>
                      <TableCell>{req.route}</TableCell>
                      <TableCell>{req.cost}</TableCell>
                      <TableCell>{req.requestedBy || "Doctor A"}</TableCell>
                      <TableCell>{req.servedBy || "-"}</TableCell>
                      <TableCell sx={{ color: req.status === "paid" ? "green" : "orange" }}>
                        {req.status} 
                      </TableCell>
                     <TableCell>
                        {req.date?.substring(0, 10) === currentDate ? (
                          // ✅ Today — allow edit and delete
                          <>
                            {req.status === "pending" && (
                              <IconButton
                                size="small"
                                color="primary"
                                onClick={() => handleEditMedication(idx)}
                              >
                                <Edit fontSize="small" />
                              </IconButton>
                            )}

                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => handleDeleteMedication(req)}
                            >
                              <Delete fontSize="small" />
                            </IconButton>
                          </>
                        ) : (
                          // 🔒 Not today — show lock icon with tooltip
                          <Tooltip title="Cannot modify medication from previous dates">
                            <span>
                              <IconButton size="small" disabled>
                                <LockIcon fontSize="small" />
                              </IconButton>
                            </span>
                          </Tooltip>
                        )}
                      </TableCell>

                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <TablePagination
            component="div"
            count={requestedMeds.length}
            page={reqMedPage}
            onPageChange={(e, newPage) => setReqMedPage(newPage)}
            rowsPerPage={reqMedRowsPerPage}
            onRowsPerPageChange={(e) => {
              setReqMedRowsPerPage(parseInt(e.target.value, 10));
              setReqMedPage(0);
            }}
            rowsPerPageOptions={[10, 20, 30]}
          />
          {/* Totals */}
        <Box
          sx={{
            mt: 1,
            p: 1.5,
            borderRadius: 2,
            background: "linear-gradient(90deg, #f3e5f5, #e8f5e9)",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" fontWeight="bold" color="warning.main">
            Pending: GH₵{" "}
            {formatWithOutSom (requestedMeds.filter((r) => r.status === "pending").reduce((sum, r) => sum + r.cost, 0))}
          </Typography>
          <Typography variant="caption" fontWeight="bold" color="success.main">
            Paid: GH₵{" "}
            {formatWithOutSom(requestedMeds.filter((r) => r.status === "paid").reduce((sum, r) => sum + r.cost, 0))}
          </Typography>
        </Box>
        </Paper>
      </Grid>
    </Grid>
  </DialogContent>
</Dialog>



{/* Medication Information Dialog */}
<Dialog 
  open={medInfoDialogOpen} 
  onClose={() => {
    setMedInfoDialogOpen(false);
    setMedInfoLoading(false);
  }}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white' }}>
    <Box display="flex" alignItems="center" gap={1}>
      <Medication />
      <Typography variant="h6">Medication Information</Typography>
    </Box>
  </DialogTitle>
  
  <DialogContent sx={{ mt: 2, minHeight: 300 }}>
    {selectedMedInfo ? (
      <Box>
        {/* Medication Name */}
        <Paper elevation={2} sx={{ p: 2, mb: 2, bgcolor: '#f5f5f5' }}>
          <Typography variant="h6" fontWeight={600} color="primary">
            {selectedMedInfo.name}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Code: {selectedMedInfo.code || 'N/A'}
          </Typography>
        </Paper>

        {/* Status & Pricing */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6}>
            <Paper elevation={1} sx={{ p: 2, textAlign: 'center' }}>
              <Typography variant="caption" color="text.secondary">
                Status
              </Typography>
              <Typography variant="h6" fontWeight={600}>
                <Chip 
                  label={selectedMedInfo.status} 
                  color={selectedMedInfo.status === 'Non Insured' ? 'warning' : 'success'}
                  sx={{ mt: 1 }}
                />
              </Typography>
            </Paper>
          </Grid>
          
          <Grid item xs={6}>
            <Paper elevation={1} sx={{ p: 2, textAlign: 'center' }}>
              <Typography variant="caption" color="text.secondary">
                             Unit Of Pricing
                           </Typography>
                           <Typography variant="h6" fontWeight={600} color="success.main" sx={{ mt: 1 }}>
                              {selectedMedInfo.pricing}
                           </Typography>
            </Paper>
          </Grid>
        </Grid>

        {/* Stock Information */}
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1.5 }}>
          Stock Availability
        </Typography>

        {medInfoLoading ? (
          <Box 
            sx={{ 
              display: 'flex', 
              flexDirection: 'column',
              alignItems: 'center', 
              justifyContent: 'center',
              minHeight: 200,
              gap: 2
            }}
          >
            <CircularProgress size={50} thickness={4} />
            <Typography variant="body2" color="text.secondary">
              Loading stock information...
            </Typography>
          </Box>
        ) : (
          <>
            {/* Dispensary Stock */}
            <Paper 
              elevation={2} 
              sx={{ 
                p: 2, 
                mb: 2,
                border: '2px solid',
                borderColor: 'primary.main',
                bgcolor: '#e3f2fd'
              }}
            >
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography variant="subtitle2" fontWeight={600}>
                    Dispensary Stock
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Available for immediate dispensing
                  </Typography>
                </Box>
                <Chip
                  label={`${selectedMedInfo.dispensary_stock || 0} units`}
                  color={
                    (selectedMedInfo.dispensary_stock || 0) > 50 
                      ? 'success' 
                      : (selectedMedInfo.dispensary_stock || 0) > 0 
                        ? 'warning' 
                        : 'error'
                  }
                  sx={{ 
                    fontWeight: 700,
                    fontSize: '1rem',
                    height: 36,
                    minWidth: 100
                  }}
                />
              </Box>
            </Paper>

            {/* Store Stock */}
            <Paper 
              elevation={2} 
              sx={{ 
                p: 2,
                border: '2px solid',
                borderColor: 'secondary.main',
                bgcolor: '#f3e5f5'
              }}
            >
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography variant="subtitle2" fontWeight={600}>
                    Store Stock
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Main inventory
                  </Typography>
                </Box>
                <Chip
                  label={
                    (selectedMedInfo.store_stock || 0) > 0 
                      ? 'In Stock' 
                      : 'Out of Stock'
                  }
                  color={(selectedMedInfo.store_stock || 0) > 0 ? 'success' : 'error'}
                  sx={{ 
                    fontWeight: 700,
                    fontSize: '1rem',
                    height: 36,
                    minWidth: 100
                  }}
                />
              </Box>
            </Paper>

            {/* Low Stock Warning */}
            {(selectedMedInfo.dispensary_stock || 0) < 10 && (selectedMedInfo.dispensary_stock || 0) > 0 && (
              <Box 
                sx={{ 
                  mt: 2, 
                  p: 1.5, 
                  bgcolor: '#fff3e0',
                  borderRadius: 1,
                  border: '1px solid #ff9800'
                }}
              >
                <Typography variant="body2" color="warning.dark" fontWeight={600}>
                  ⚠️ Low Stock Alert: Please restock soon
                </Typography>
              </Box>
            )}

            {/* Out of Stock Warning */}
            {(selectedMedInfo.dispensary_stock || 0) === 0 && (
              <Box 
                sx={{ 
                  mt: 2, 
                  p: 1.5, 
                  bgcolor: '#ffebee',
                  borderRadius: 1,
                  border: '1px solid #f44336'
                }}
              >
                <Typography variant="body2" color="error.dark" fontWeight={600}>
                  ❌ Out of Stock: Cannot dispense at this time
                </Typography>
              </Box>
            )}
          </>
        )}
      </Box>
    ) : (
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          minHeight: 300
        }}
      >
        <CircularProgress />
      </Box>
    )}
  </DialogContent>
  
  <DialogActions>
    <Button 
      onClick={() => {
        setMedInfoDialogOpen(false);
        setMedInfoLoading(false);
        setSelectedMedInfo(null);
      }} 
      variant="contained"
      disabled={medInfoLoading}
    >
      Close
    </Button>
  </DialogActions>
</Dialog>


{/* ALL History */}
<MedicalHistoryDialog
  open={medHistoryOpen}
  onClose={() => setMedHistoryOpen(false)}
  patientData={selectedPatient}
/>

{/* lab History */}
<LabHistoryDialog
  open={labHistoryOpen}
  onClose={() => setlabHistoryOpen(false)}
  patientData={selectedPatient}
/>


{/* Scan History */}
<ScanHistoryDialog
  open={ScanHistoryOpen}
  onClose={() => setScanHistoryOpen(false)}
  patientData={selectedPatient}
/>


<VitalsHistoryDialog
  open={vitalsHistoryOpen}
  onClose={() => setVitalsHistoryOpen(false)}
  patientData={selectedPatient}
/>


 {/* Medication History */}
    <MedicationHistory
    open={openmedHis}
    onClose={() => setopenmedHis(false)}
    id={selectedPatient ? selectedPatient.id: ''}
    // onSubmit={getCCCData}
  />


  {/* ── Stock Warning Dialog ── */}
<Dialog
  open={stockWarningDialog}
  onClose={() => !notifyingPharmacy && setStockWarningDialog(false)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle sx={{ p: 0 }}>
    <Box sx={{
      px: 3, py: 2,
      background: 'linear-gradient(135deg, #da231d 0%, #da231d 100%)',
      color: 'white',
      display: 'flex', justifyContent: 'space-between', alignItems: 'center'
    }}>
      <Typography variant="h6" fontWeight={700}>⚠️ Insufficient Stock</Typography>
      <IconButton
        onClick={() => setStockWarningDialog(false)}
        disabled={notifyingPharmacy}
        sx={{ color: 'white' }}
      >
        <Close />
      </IconButton>
    </Box>
  </DialogTitle>

  <DialogContent sx={{ pt: 3 }}>
    {stockWarningInfo && (
      <Box>
        <Typography variant="body1" sx={{ mb: 2 }}>
          There is not enough stock in the dispensary for:
        </Typography>
        <Paper sx={{ p: 2, mb: 2, bgcolor: '#fff3e0', border: '1px solid #ff9800', borderRadius: 2 }}>
          <Typography fontWeight={700} fontSize="1rem" color="warning.dark">
            {stockWarningInfo.drugName}
          </Typography>
          <Box sx={{ mt: 1, display: 'flex', gap: 3 }}>
            <Box>
              <Typography variant="caption" color="text.secondary">Requested</Typography>
              <Typography fontWeight={700} color="primary">{stockWarningInfo.requestedQty}</Typography>
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">Available</Typography>
              <Typography fontWeight={700} color="success.main">{stockWarningInfo.availableStock}</Typography>
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">Shortfall</Typography>
              <Typography fontWeight={700} color="error">
                {stockWarningInfo.requestedQty - stockWarningInfo.availableStock}
              </Typography>
            </Box>
          </Box>
        </Paper>
        <Typography variant="body2" color="text.secondary">
          You can notify the pharmacy to restock, or cancel request.
        </Typography>
      </Box>
    )}
  </DialogContent>

  <DialogActions sx={{ p: 2, gap: 1, flexWrap: 'wrap' }}>
    <Button
      variant="contained"
      color="warning"
      disabled={notifyingPharmacy}
      onClick={handleNotifyPharmacy}
      sx={{ fontWeight: 600, flex: 1 }}
    >
      {notifyingPharmacy
        ? <CircularProgress size={20} />
        : '📢 Notify Pharmacy & Submit'}
    </Button>
    <Button
      variant="outlined"
      color="error"
      disabled={notifyingPharmacy}
      onClick={() => setStockWarningDialog(false)}
      sx={{ fontWeight: 600, flex: 1 }}
    >
      Cancel
    </Button>
  </DialogActions>
</Dialog>

<RestockNotificationDialog
  onSeen={() => setRestockCount(0)}
  onNotificationsLoaded={(count) => setRestockCount(count)}
/>


<WardRoundsDialog
  open={wardRoundsOpen}
  onClose={handleWardRoundsClose}

  patient={{
    name: selectedPatient?.fullName,
    id: selectedPatient?.id,
    age: selectedPatient?.age,
    gender: selectedPatient?.gender,
    phone: selectedPatient?.tel,
    insurance:selectedPatient?.insurance,
    currentUser:currentUser
  }}


  fields={{
    startDate: selectedPatient?.visitDate ,
    
  }}

  utils={{
    suggestionsData,
    iconStyle,
    handleSuggest,
    setHasEdited,
  }}


  diagnosisOptions={diagnosisOptions}
  selectedDiagnoses={selectedDiagnoses}
  setSelectedDiagnoses={setSelectedDiagnoses}
  saveOrUpdateDiagnosis={saveOrUpdateDiagnosis}

  procedureOptions={procedureOptions}
  selectedProcedures={selectedProcedures}
  setSelectedProcedures={setSelectedProcedures}
  saveOrUpdateProcedure={saveOrUpdateProcedure}
/>


 <SpecialPrecautionDialog
  open={precautionDialogOpen}
  onClose={() => setPrecautionDialogOpen(false)}
  patient={selectedPatient}
/>

        </>
        )}
</Container>
</Box>
  );
};

export default InPatient;



